import React, { Component } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import DayPicker, { DateUtils } from 'react-day-picker'; //npm install react-day-picker --save
import DatePicker from "react-datepicker"; // npm install react - datepicker --save
import DateBox from 'devextreme-react/date-box';
import Autosuggest from 'react-autosuggest'; //npm install react-autosuggest --save
import autocomplete from 'react-google-places-autocomplete';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import NumberFormat from 'react-number-format';
import NumericInput from 'react-numeric-input'; //npm install react-numeric-input --save
import { getRequestParams } from '../../helpers/globalfunctions.js';
import { CardTypes } from '../../helpers/fixcodes.js';
import { LoadPanel } from 'devextreme-react/load-panel';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ConfirmQuoteComponent } from '../Shared/ConfirmQuoteComponent';
import { VoucherEmailComponent } from '../Shared/VoucherEmailComponent';

import "react-datepicker/dist/react-datepicker.css";
import 'react-day-picker/lib/style.css';

const MySwal = withReactContent(Swal)
const google = window.google;
const position = { of: '#bookingdiv' };

function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function renderSuggestion(suggestion) {
    if (suggestion.isNotFound) {
        return (
            <span>
                Data not found!
            </span>
        );
    }
    return (
        <span>{suggestion.name}</span>
    );
}
function shouldRenderSuggestions(value, reason) {
    return value.trim().length > 2;
}

const terminalTypeData = [
    {
        "id": 1,
        "name": "Domestic",
    },
    {
        "id": 2,
        "name": "International",
    },
    {
        "id": 3,
        "name": "Hangar",
    },
    {
        "id": 4,
        "name": "Military",
    },
    {
        "id": 5,
        "name": "Regional",
    },
    {
        "id": 6,
        "name": "Unknown",
    },
]

const existingCreditCardData = [
    {
        "id": 1,
        "name": "XXXXXXXXXXXX1234",
        "expiry": "02/25",
        "cardType": "VISA",
        "paymentToken": "xpiskdu"
    },
    {
        "id": 2,
        "name": "XXXXXXXXXXXX6545",
        "expiry": "02/25",
        "cardType": "VISA",
        "paymentToken": "xpiskdu"
    },
    {
        "id": 3,
        "name": "XXXXXXXXXXXX5213",
        "expiry": "02/25",
        "cardType": "VISA",
        "paymentToken": "xpiskdu"
    },
    {
        "id": 4,
        "name": "XXXXXXXXXXXX0251",
        "expiry": "02/25",
        "cardType": "VISA",
        "paymentToken": "xpiskdu"
    },
    {
        "id": 5,
        "name": "XXXXXXXXXXXX8700",
        "expiry": "02/25",
        "cardType": "VISA",
        "paymentToken": "xpiskdu"
    },
]

let rideTypeId = 0;
let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));

export class QuoteComponent extends Component {
    static displayName = QuoteComponent.name;

    constructor(props) {
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        super(props);


        this.autocompletePickup = null;
        this.state = {
            isSubmited: false,
            isCancelSubmited: false,
            isEmailSubmited: false,
            quoteId: this.props.location.state == undefined ? 0 : this.props.location.state.quoteId,
            sourceUrl: this.props.location.state == undefined ? "" : this.props.location.state.sourceUrl, // Send from calling paging (Quotation list)
            sourceState: this.props.location.state == undefined ? "" : this.props.location.state.sourceState,  // Send from calling paging (Quotation list)
            rateLookup: this.props.location.state == undefined ? null : (this.props.location.state.rateLookup == undefined ? null : this.props.location.state.rateLookup),
            tripDetails: null,
            paxFirstName: '',
            paxLastName: '',
            countryCodePhone: '1',
            phoneNumber: '',
            countryCode: '1',
            mobileNumber: '',
            email: '',
            isSendEmail: false,
            poNumber: '',

            bookingAddress: [],
            dropdownZone: [],
            isPickupGoogleBooking: false,
            pickupSuggestions: [],
            pickupLocation: "",
            pickupZoneId: 0,
            pickupAddress: "",
            pickupAddressType: "",
            pickupCity: "",
            pickupState: "",
            pickupZipCode: "",
            pickupLatitude: 0,
            pickupLongitude: 0,
            isDropoffGoogleBooking: false,
            dropoffSuggestions: [],
            dropoffLocation: "",
            dropoffZoneId: 0,
            dropoffAddress: "",
            dropoffAddressType: "",
            dropoffCity: "",
            dropoffState: "",
            dropoffZipCode: "",
            dropoffLatitude: 0,
            dropoffLongitude: 0,
            serviceSourceId: 1,
            dropdownAffiliates: [],
            otherAffiliateId: 0,

            dropdownAirline: [],
            airlineId: 0,
            flightNumber: '',
            terminalType: 1,
            terminal: '',
            flightTime: currentTime,

            airlineIdReturn: 0,
            flightNumberReturn: '',
            terminalTypeReturn: 1,
            terminalReturn: '',
            flightTimeReturn: currentTime,

            orderByName: '',
            countryCodeOrderPhone: '',
            phoneNumberOrder: '',
            emailOrder: '',
            dropdownReservationMode: [],
            reservationModeId: 0,
            puDateTime: currentTime,
            puDateTimeReturn: currentTime,

            doDateTime: currentTime,
            tripDuration: 0,
            dropdownVehicleType: [],
            vehicleTypeId: 0,
            noOfPax: 1,
            noOfPaxReturn: 1,
            luggage: 0,
            noOfTrip: 1,
            isAccessible: false,
            isVipTrip: false,
            isPriorityTrip: false,
            isMeetGreet: false,
            tripTypeId: "1",
            isLockRates: false,
            recurringTypeId: 2,
            recurringEndDate: "",
            selectedDays: [],
            isWeekSun: false,
            isWeekMon: false,
            isWeekTue: false,
            isWeekWed: false,
            isWeekThu: false,
            isWeekFri: false,
            isWeekSat: false,
            isMonthSun: false,
            isMonthMon: false,
            isMonthTue: false,
            isMonthWed: false,
            isMonthThu: false,
            isMonthFri: false,
            isMonthSat: false,
            specialInstruction: "",
            permanentRemark: "",
            pickupNotes: "",
            billToNotes: "",
            customerRateTax: null,


            dropdownPaymentType: [],
            paymentTypeId: 1,
            dropdownVoucherCompany: [],
            voucherCompanyId: 0,
            paymentTermId: 1,
            dropdownExistingCards: [],
            existingCardId: 0,
            cardExpiry: "",
            cardType: "",
            cardImage: 'data:image/svg+xml;base64,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',
            creditCard: "",
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            chargeTo: "",
            voucherCode: "",

            rateId: 0,
            rideAmount: 0.000,
            tollAmount: 0.000,
            tipAmount: 0.000,
            otAmount: 0.000,
            serviceFeeAmount: 0.000,
            fuelSurcharge: 0.000,
            parkingFee: 0.000,
            tourGuideCharge: 0.000,
            payToTourGuide: 0.000,
            extraAmount: 0.000,
            extraAmountFor: "",
            waitingCharge: 0.000,
            waitingTime: 0,
            waitingChargeTotal: 0.000,
            extraStopCharge: 0.000,
            noOfStops: 0,
            stopTotal: 0.000,
            meetGreet: 0.000,
            mgToPay: "2",
            dropdownGreeter: [],
            payMeetGreetId: 0,
            payMeetGreetAmount: 0.000,
            mgDriverComms: "1",
            dropdownAgentCommission: [],
            agentCommissionId: 0,
            agentCommissionName: "",
            agentCommissionAmount: 0.000,
            discount: 0.000,

            portAuthority: 0.000,
            utitity: 0.000,
            countyTax: 0.000,
            congestionTax: 0.000,
            workCompantation: 0.000,
            salesTax: 0.000,
            grossAmount: 0.000,
            totalFare: 0.000,
            paidAmount: 0.000,

            taxOptionId: "3",
            isAppliedPortAuthority: true,
            isAppliedSalesTax: true,
            isAppliedCountyTax: true,
            isAppliedCongestionTax: true,


            loadPanelVisible: false,

            errors: {
                paxFirstName: "",
                paxLastName: "",
                countryCode: "",
                mobileNumber: "",
                email: "",
                pickupLocation: "",
                pickupZoneId: "",
                dropoffLocation: "",
                dropoffZoneId: "",
                otherAffiliateId: "",
                puDateTime: "",
                doDateTime: "",
                flightTime: "",
                flightNumber: "",
                terminalType: "",
                flightNumberReturn: "",
                terminalTypeReturn: "",
                flightTimeReturn: "",
                orderByName: "",
                reservationModeId: "",
                vehicleTypeId: "",
                noOfTrip: "",
                noOfPax: "",
                noOfPaxReturn: "",
                recurringEndDate: "",
                recurring: "",

                rideAmount: "",
                payMeetGreetId: "",
                payMeetGreetAmount: "",

                paymentTypeId: "",
                paidAmount: "",
                checkNumber: "",
                checkDate: "",
                checkBank: "",
                existingCardId: "",
                creditCard: "",
                cardType: "",
                cardExpiry: "",
                voucherCompanyId: "",
                voucherCode: "",
            }
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handlePickupZoneChange = this.handlePickupZoneChange.bind(this);
        this.handleDropoffZoneChange = this.handleDropoffZoneChange.bind(this);
        this.handleAirlineChange = this.handleAirlineChange.bind(this);
        this.handleAirlineReturnChange = this.handleAirlineReturnChange.bind(this);
        this.handleVehicleTypeChange = this.handleVehicleTypeChange.bind(this);
        this.handleAffiliateChange = this.handleAffiliateChange.bind(this);
        this.handleReservationModeChange = this.handleReservationModeChange.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handlePaxCountChange = this.handlePaxCountChange.bind(this);
        this.handlePaxCountReturnChange = this.handlePaxCountReturnChange.bind(this);
        this.handleTripTypeChange = this.handleTripTypeChange.bind(this);
        this.handleTaxOptionChange = this.handleTaxOptionChange.bind(this);
        this.handleGreeterChange = this.handleGreeterChange.bind(this);
        this.handleAgentCommissionChange = this.handleAgentCommissionChange.bind(this);

        this.handlePaymentTypeChange = this.handlePaymentTypeChange.bind(this);
        this.handleVoucherCompanyChange = this.handleVoucherCompanyChange.bind(this);
        this.handleExistingCardChange = this.handleExistingCardChange.bind(this);

        this.loadPage = this.loadPage.bind(this);
        this.getAirlines = this.getAirlines.bind(this);
        this.getVehicleType = this.getVehicleType.bind(this);
        this.getAffiliates = this.getAffiliates.bind(this);
        this.getReservationModes = this.getReservationModes.bind(this);
        this.getBookingSuggestions = this.getBookingSuggestions.bind(this);
        this.getZones = this.getZones.bind(this);
        this.getPickupSuggestionValue = this.getPickupSuggestionValue.bind(this);
        this.onChangePickupLocation = this.onChangePickupLocation.bind(this);
        this.onBlurPickupLocation = this.onBlurPickupLocation.bind(this);
        this.getDropoffSuggestionValue = this.getDropoffSuggestionValue.bind(this);
        this.getGreeter = this.getGreeter.bind(this);
        this.getAgentCommission = this.getAgentCommission.bind(this);
        this.getRideTypeId = this.getRideTypeId.bind(this);

        this.getPaymentType = this.getPaymentType.bind(this);
        this.getVoucherCompany = this.getVoucherCompany.bind(this);
        this.getExistingCards = this.getExistingCards.bind(this);

        this.handleValidation = this.handleValidation.bind(this);
        this.handleQuoteSubmit = this.handleQuoteSubmit.bind(this);

        this.handleMgToPay = this.handleMgToPay.bind(this);
        this.handleDriverCommissionPay = this.handleDriverCommissionPay.bind(this);

        this.cardExpiry = this.cardExpiry.bind(this);
        this.limitMonthCreditCard = this.limitMonthCreditCard.bind(this);
        this.limitYearCreditCard = this.limitYearCreditCard.bind(this);
        this.handleRecurringEndDateChange = this.handleRecurringEndDateChange.bind(this);
        this.handleFlightDateTimeChange = this.handleFlightDateTimeChange.bind(this);
        this.handleFlightDateTimeReturnChange = this.handleFlightDateTimeReturnChange.bind(this);
        this.handlePickupDateTimeChange = this.handlePickupDateTimeChange.bind(this);
        this.handlePickupDateTimeReturnChange = this.handlePickupDateTimeReturnChange.bind(this);

        this.handlePlaceSearch = this.handlePlaceSearch.bind(this);
        this.handlePickupPlaceSelect = this.handlePickupPlaceSelect.bind(this);
        this.handlePickupToggleChange = this.handlePickupToggleChange.bind(this);

        this.handleDropoffPlaceSelect = this.handleDropoffPlaceSelect.bind(this);
        this.handleDropoffToggleChange = this.handleDropoffToggleChange.bind(this);
        this.handleMeetGreetChange = this.handleMeetGreetChange.bind(this);

        this.getCustomerRateTaxSetting = this.getCustomerRateTaxSetting.bind(this);
        this.getDaysOfMonthlyRec = this.getDaysOfMonthlyRec.bind(this);
        this.getDaysOfWeeklyRec = this.getDaysOfWeeklyRec.bind(this);
        this.getDaysOfDailyRec = this.getDaysOfDailyRec.bind(this);
        this.getMonthlyRecurringDays = this.getMonthlyRecurringDays.bind(this);
        this.getWeeklyRecurringDays = this.getWeeklyRecurringDays.bind(this);
        this.getDailyRecurringDays = this.getDailyRecurringDays.bind(this);
        this.diffDays = this.diffDays.bind(this);
        this.getRecurringPuDateArrayList = this.getRecurringPuDateArrayList.bind(this);

        this.checkDuplicateReservation = this.checkDuplicateReservation.bind(this);
        this.bookReservation = this.bookReservation.bind(this);
        this.clearAllControls = this.clearAllControls.bind(this);

        this.fillRateControls = this.fillRateControls.bind(this);
        this.handleRateChange = this.handleRateChange.bind(this);
        this.calculateFare = this.calculateFare.bind(this);

        this.getTripChangesDetails = this.getTripChangesDetails.bind(this);
        this.goToBack = this.goToBack.bind(this);
        this.handleCancelSubmit = this.handleCancelSubmit.bind(this);
        this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
        this.handleConfirmSubmit = this.handleConfirmSubmit.bind(this);
        this.openEmailModal = this.openEmailModal.bind(this);
        this.handleDownload = this.handleDownload.bind(this);

    };


    async getBookingSuggestions(value) {
        const escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
            return [];
        }

        const requestParams = getRequestParams('GET', '');
        const response = await fetch('address-search-api/0/0/' + value, requestParams);
        const data = await response.json();

        this.setState({ bookingAddress: data === false ? [] : data.addressSearchList })

        const regex = new RegExp('^' + escapedValue, 'i');

        const suggestions = (this.state.bookingAddress.length > 0) ? this.state.bookingAddress.filter(bookingAddress => regex.test(bookingAddress.name)) : [];

        if (suggestions.length === 0) {
            return [
                { isNotFound: true }
            ];
        }

        return suggestions;
    }

    onChangePickupLocation = (event, { newValue }) => {
        this.setState({
            pickupLocation: newValue
        });
        this.state.errors["pickupLocation"] = "";
    };

    onBlurPickupLocation = (event, { value }) => {
        const index2 = (this.state.bookingAddress.length > 0) ? this.state.bookingAddress.map(item => item.name).indexOf(this.state.pickupLocation) : -1;
        if (index2 === -1) {
            this.setState({
                pickupLocation: "",
                pickupAddress: "",
                pickupAddressType: "",
                pickupCity: "",
                pickupState: "",
                pickupZipCode: "",
                pickupZoneId: 0,
                pickupLatitude: 0,
                pickupLongitude: 0
            });
            this.getRideTypeId(0, this.state.dropoffZoneId);
        }
        this.state.errors["pickupLocation"] = "";
    };

    getPickupSuggestionValue(suggestion) {
        if (suggestion.isNotFound) {
            return "";
        }
        this.setState({
            pickupLocation: suggestion.name,
            pickupAddress: suggestion.address,
            pickupAddressType: suggestion.addressType,
            pickupCity: suggestion.city,
            pickupState: suggestion.state,
            pickupZipCode: suggestion.zipCode,
            pickupZoneId: suggestion.zoneId,
            pickupLatitude: suggestion.latitude,
            pickupLongitude: suggestion.longitude
        });
        if (this.state.dropdownZone.findIndex(opt => opt.id == suggestion.zoneId) < 0) {
            this.setState({
                pickupZoneId: 0,
            });
        } else {
            this.getRideTypeId(suggestion.zoneId, this.state.dropoffZoneId);
            this.getCustomerRateTaxSetting(suggestion.id, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet);
            this.state.errors["pickupZoneId"] = "";
        }

        this.state.errors["pickupLocation"] = "";
        return suggestion.name;
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onPickupSuggestionsFetchRequested = ({ value }) => {
        this.getBookingSuggestions(value).then(data => this.setState({
            pickupSuggestions: data
        }));
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onPickupSuggestionsClearRequested = () => {
        this.setState({
            pickupSuggestions: []
        });
        this.state.errors["pickupLocation"] = "";
    };

    onChangeDropoffLocation = (event, { newValue }) => {
        this.setState({
            dropoffLocation: newValue
        });

        this.state.errors["dropoffLocation"] = "";
    };


    onBlurDropoffLocation = (event, { value }) => {
        const index2 = (this.state.bookingAddress.length > 0) ? this.state.bookingAddress.map(item => item.name).indexOf(this.state.dropoffLocation) : -1;
        if (index2 === -1) {
            this.setState({
                dropoffLocation: "",
                dropoffAddress: "",
                dropoffAddressType: "",
                dropoffCity: "",
                dropoffState: "",
                dropoffZipCode: "",
                dropoffZoneId: 0,
                dropoffLatitude: 0,
                dropoffLongitude: 0
            });
            this.getRideTypeId(this.state.pickupZoneId, 0);
        }
        this.state.errors["dropoffLocation"] = "";
    };

    getDropoffSuggestionValue(suggestion) {
        if (suggestion.isNotFound) {
            return "";
        }
        this.setState({
            dropoffLocation: suggestion.name,
            dropoffAddress: suggestion.address,
            dropoffAddressType: suggestion.addressType,
            dropoffCity: suggestion.city,
            dropoffState: suggestion.state,
            dropoffZipCode: suggestion.zipCode,
            dropoffZoneId: suggestion.zoneId,
            dropoffLatitude: suggestion.latitude,
            dropoffLongitude: suggestion.longitude
        });

        if (this.state.dropdownZone.findIndex(opt => opt.id == suggestion.zoneId) < 0) {
            this.setState({
                dropoffZoneId: 0,
            });
        } else {
            this.getRideTypeId(this.state.pickupZoneId, suggestion.zoneId);
            this.getCustomerRateTaxSetting(this.state.pickupZoneId, suggestion.zoneId, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet);
            this.state.errors["dropoffZoneId"] = "";
        }

        this.state.errors["dropoffLocation"] = "";

        return suggestion.name;
    }

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onDropoffSuggestionsFetchRequested = ({ value }) => {
        this.getBookingSuggestions(value).then(data => this.setState({
            dropoffSuggestions: data
        }));
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onDropoffSuggestionsClearRequested = () => {
        this.setState({
            dropoffSuggestions: []
        });
        this.state.errors["dropoffLocation"] = "";
    };

    handleDayClick(day, { selected }) {
        const { selectedDays } = this.state;
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            selectedDays.splice(selectedIndex, 1);
        } else {
            selectedDays.push(day);
        }
        this.setState({ selectedDays });
        this.state.errors["recurring"] = "";
    }

    async getAirlines() {
        try {
            const data = JSON.parse(sessionStorage.getItem("session_airlines"));
            if (data === null) {
                const requestParams = getRequestParams('GET', '');
                const response = await fetch('air-line-api/' + 0, requestParams);
                const data = await response.json();
                if (!this._isMounted) return;
                this.setState({ dropdownAirline: data.airLine || [] });
            }
            else {
                if (!this._isMounted) return;
                this.setState({ dropdownAirline: data.airLine || [] });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getVehicleType() {
        try {
            const data = JSON.parse(sessionStorage.getItem("session_vehicletype"));
            if (data === null) {
                var newObject = new Object();
                const requestParams = getRequestParams('POST', newObject);
                const response = await fetch('vehicletype-api/vehicletype', requestParams);
                const data = await response.json();
                if (!this._isMounted) return;
                this.setState({ dropdownVehicleType: data.apiVehicleType || [] });
            }
            else {
                if (!this._isMounted) return;
                this.setState({ dropdownVehicleType: data.data.apiVehicleType || [] });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getAffiliates() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('account-api/affliate-dropdown', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownAffiliates: data.affiliatesDropdownList || [] });
        } catch (e) {
            console.log(e);
        }
    }

    async getReservationModes() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('reservation-mode-api', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownReservationMode: data.reservationMode || [] });
        } catch (e) {
            console.log(e);
        }
    }

    async getZones() {
        try {
            const data = JSON.parse(sessionStorage.getItem("session_zones"));
            if (data === null) {
                const requestParams = getRequestParams('GET', '');
                const response = await fetch('serviceAreaZone-api/zone-dropdown/' + 0 + "/" + 0, requestParams);
                const data = await response.json();
                if (!this._isMounted) return;
                this.setState({ dropdownZone: data.locationServiceAreaZoneList || [] });
            }
            else {
                if (!this._isMounted) return;
                this.setState({ dropdownZone: data.locationServiceAreaZoneList || [] });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getGreeter() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('account-api/greeter-dropdown/', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownGreeter: data.users || [] });
        } catch (e) {
            console.log(e);
        }
    }

    async getAgentCommission() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('commission-agent-api/commission-agent-dropdown/', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownAgentCommission: data.commissionAgentDropdownList || [] });
        } catch (e) {
            console.log(e);
        }
    }

    async getPaymentType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('paymenttype-api/dropdownlist', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownPaymentType: data.paymentType || [] });
        } catch (e) {
            console.log(e);
        }
    }

    async getVoucherCompany() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('account-api/voucher-customer-dropdown/', requestParams);
            const data = await response.json();
            if (!this._isMounted) return;
            this.setState({ dropdownVoucherCompany: data.customers || [] });
        } catch (e) {
            console.log(e);
        }
    }

    getExistingCards() {
        try {
            this.setState({ dropdownExistingCards: existingCreditCardData });
        } catch (e) {
            console.log(e);
        }
    }

    async getTripDetails() {
        var newObject = new Object();
        newObject.QuatationId = 0;
        newObject.QuoteStatusId = "";

        const requestParams = getRequestParams('POST', newObject);
        const response = await fetch('quotation-api/' + parseInt(this.state.quoteId) + '/list/', requestParams);
        const data = await response.json();
        if (!this._isMounted) return;
        this.setState({
            tripDetails: data.quoteDetails[0],
        });
    }

    async componentDidMount() {
        this._isMounted = true;
        this.setState({
            loadPanelVisible: true
        });
        await this.loadPage();
        if (this._isMounted) {
            this.setState({
                loadPanelVisible: false
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async loadPage() {
        await this.getAirlines();
        await this.getVehicleType();
        //await this.getAffiliates();
        await this.getReservationModes();
        await this.getZones();
        //await this.getGreeter();
        //await this.getAgentCommission();
        //await this.getPaymentType();
        //await this.getVoucherCompany();
        //await this.getExistingCards();

        if (parseInt(this.state.quoteId) > 0) {
            await this.getTripDetails();
        }

        if (this.state.tripDetails != null) {
            rideTypeId = parseInt(this.state.tripDetails.rideTypeId);
            let puZone = null, doZone = null;
            if (rideTypeId == 1) {
                puZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.puAreaId);
                doZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.doAreaId);
            } else if (rideTypeId == 2) {
                puZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.puAreaId);
                doZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.doAreaId);
            } else if (rideTypeId == 3) {
                puZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.puAreaId);
                doZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.doAreaId);
            } else {
                puZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.puAreaId);
                doZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.doAreaId);
            }

            let paxCount = (parseInt(this.state.noOfPax | 0));

            await this.getCustomerRateTaxSetting(puZone.id, doZone.id, new Date(this.state.tripDetails.puDateTime), this.state.tripDetails.apiVehicleTypeId, paxCount, 0, this.state.tripDetails.isMgRequired)
            
            this.setState({
                paxFirstName: this.state.tripDetails.firstName,
                paxLastName: this.state.tripDetails.lastName,
                countryCodePhone: this.state.tripDetails.countryCode,
                phoneNumber: this.state.tripDetails.phoneNo,
                countryCode: this.state.tripDetails.cellCountryCode,
                mobileNumber: this.state.tripDetails.mobileNo,
                email: this.state.tripDetails.email,

                isPickupGoogleBooking: false,
                pickupLocation: this.state.tripDetails.puLocationName,
                pickupZoneId: puZone.id,
                pickupAddress: this.state.tripDetails.puAddress,
                pickupAddressType: "",
                pickupCity: this.state.tripDetails.puCity,
                pickupState: this.state.tripDetails.puStateName,
                pickupZipCode: this.state.tripDetails.puZipCode,
                pickupLatitude: this.state.tripDetails.puLatitude,
                pickupLongitude: this.state.tripDetails.puLongitude,
                isDropoffGoogleBooking: false,
                dropoffLocation: this.state.tripDetails.doLocationName,
                dropoffZoneId: doZone.id,
                dropoffAddress: this.state.tripDetails.doAddress,
                dropoffAddressType: "",
                dropoffCity: this.state.tripDetails.doCity,
                dropoffState: this.state.tripDetails.doStateName,
                dropoffZipCode: this.state.tripDetails.doZipCode,
                dropoffLatitude: this.state.tripDetails.doLatitude,
                dropoffLongitude: this.state.tripDetails.doLongitude,
                //serviceSourceId: this.state.tripDetails.serviceSourceId,
                //otherAffiliateId: this.state.tripDetails.serviceSourceAffiliateId,

                airlineId: (rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puAirlineId : this.state.tripDetails.doAirlineId,
                flightNumber: (rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puAirlineNo : this.state.tripDetails.doAirlineNo,
                terminalType: (rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puTerminalTypeId : this.state.tripDetails.doTerminalTypeId,
                terminal: (rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puFlightTerminal : this.state.tripDetails.doFlightTerminal,
                flightTime: (rideTypeId == 1 || rideTypeId == 3) ? new Date(this.state.tripDetails.puFlightDateTime) : new Date(this.state.tripDetails.doFlightDateTime),

                airlineIdReturn: (rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puAirlineId : this.state.tripDetails.DoAirlineId,
                flightNumberReturn: '',
                terminalTypeReturn: 1,
                terminalReturn: '',
                flightTimeReturn: currentTime,

                orderByName: this.state.tripDetails.orderBy,
                //countryCodeOrderPhone: this.state.tripDetails.orderByCountryCode,
                phoneNumberOrder: this.state.tripDetails.orderPhone,
                //emailOrder: this.state.tripDetails.orderByEmail,
                reservationModeId: this.state.tripDetails.reservationModeId,
                puDateTime: new Date(this.state.tripDetails.puDateTime),
                puDateTimeReturn: currentTime,

                //doDateTime: new Date(this.state.tripDetails.approxDropoffTime),
                //tripDuration: this.state.tripDetails.approxTripDurationMin,
                vehicleTypeId: this.state.tripDetails.apiVehicleTypeId,
                noOfPax: this.state.tripDetails.adultNo,
                noOfPaxReturn: 1,
                luggage: this.state.tripDetails.baggageCount,
                noOfTrip: 1,
                isAccessible: this.state.tripDetails.isAccessible,
                isVipTrip: this.state.tripDetails.vip === 'Y' ? true : false,
                isPriorityTrip: this.state.tripDetails.priority === 'Y' ? true : false,
                isMeetGreet: this.state.tripDetails.isMgRequired,

                //poNumber: this.state.tripDetails.crewPo == null ? "" : this.state.tripDetails.crewPo,
                noOfTrip: 1,
                tripTypeId: "1",
                isLockRates: this.state.tripDetails.rateLocked,

                recurringTypeId: 2,
                recurringEndDate: "",
                selectedDays: [],
                isWeekSun: false,
                isWeekMon: false,
                isWeekTue: false,
                isWeekWed: false,
                isWeekThu: false,
                isWeekFri: false,
                isWeekSat: false,
                isMonthSun: false,
                isMonthMon: false,
                isMonthTue: false,
                isMonthWed: false,
                isMonthThu: false,
                isMonthFri: false,
                isMonthSat: false,
                specialInstruction: this.state.tripDetails.specialInstruction,
                permanentRemark: this.state.tripDetails.permanentRemark,
                //pickupNotes: this.state.tripDetails.pickUpNotes,
                //billToNotes: this.state.tripDetails.billToNotes,

                paymentTypeId: this.state.tripDetails.paymentTypeId,
                //voucherCompanyId: this.state.tripDetails.voucherCompany,
                paymentTermId: this.state.tripDetails.partialPay == false ? 1 : 2,
                existingCardId: 0,
                cardExpiry: "",
                cardType: "",
                cardImage: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTc2IDM3NyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbGFjZWhvbGRlcjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9InBsYWNlaG9sZGVyIj4gICAgICAgICAgICA8cGF0aCBkPSJNNTI3LjkzMzc5MywzNzYuOTk4MjggTDQ4LjA2NjIwNjksMzc2Ljk5ODI4IEMzNS40MjM0ODAzLDM3Ny4xMDM5NjggMjMuMjU2NTg2NCwzNzIuMTg3ODkgMTQuMjQyMzI4MSwzNjMuMzMxNjE4IEM1LjIyODA2OTc1LDM1NC40NzUzNDYgMC4xMDQ5MTcxMDIsMzQyLjQwNDQwNyAwLDMyOS43NzQ0OTQgTDAsNDcuMjI1NDU1NCBDMC4xMDQ5MTcxMDIsMzQuNTk1NTQyNSA1LjIyODA2OTc1LDIyLjUyNDYwNCAxNC4yNDIzMjgxLDEzLjY2ODMzMTkgQzIzLjI1NjU4NjQsNC44MTIwNTk4NSAzNS40MjM0ODAzLC0wLjEwNDAxODI5NiA0OC4wNjYyMDY5LDAuMDAxNjY5NDg2NDYgTDUyNy45MzM3OTMsMC4wMDE2Njk0ODY0NiBDNTQwLjU3NjUyLC0wLjEwNDAxODI5NiA1NTIuNzQzNDE0LDQuODEyMDU5ODUgNTYxLjc1NzY3MiwxMy42NjgzMzE5IEM1NzAuNzcxOTMsMjIuNTI0NjA0IDU3NS44OTUwODMsMzQuNTk1NTQyNSA1NzYsNDcuMjI1NDU1NCBMNTc2LDMyOS45NzI5MTMgQzU3NS42NzI3ODYsMzU2LjE5NTY2MyA1NTQuMTg0MjczLDM3Ny4yMTg4NTcgNTI3LjkzMzc5MywzNzYuOTk4MjggWiIgaWQ9InNoYXBlIiBmaWxsPSIjRThFQkVFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMjAiIHg9IjQxOCIgeT0iNTgiIHdpZHRoPSI5MSIgaGVpZ2h0PSI2MyIgcng9IjMwIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSI1MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iIzc1NzU3NSIgeD0iNDEzIiB5PSIyMDgiIHdpZHRoPSIxMDciIGhlaWdodD0iNDAiIHJ4PSI4Ij48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSIyOTMiIHk9IjIwOCIgd2lkdGg9IjEwNyIgaGVpZ2h0PSI0MCIgcng9IjgiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiM3NTc1NzUiIHg9IjE3MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
                creditCard: "",
                //checkNumber: this.state.tripDetails.chqNumber,
                //checkDate: (this.state.tripDetails.chqDate != "1900-01-01T00:00:00") ? new Date(this.state.tripDetails.chqDate) : currentTime,
                //checkBank: this.state.tripDetails.chqBankName,
                chargeTo: "",
                //voucherCode: this.state.tripDetails.voucherNo,

                rideAmount: this.state.tripDetails.rideAmount,
                tollAmount: this.state.tripDetails.tollAmount,
                tipAmount: this.state.tripDetails.tipAmount,
                otAmount: this.state.tripDetails.ot,
                serviceFeeAmount: this.state.tripDetails.serviceFee,
                fuelSurcharge: this.state.tripDetails.fuelSurCharge,
                parkingFee: this.state.tripDetails.parking,
                tourGuideCharge: this.state.tripDetails.tourGuideCharge,
                payToTourGuide: this.state.tripDetails.payToTourGuide,
                extraAmount: this.state.tripDetails.extraAmount,
                extraAmountFor: this.state.tripDetails.extraAmountFor,
                waitingCharge: this.state.tripDetails.waitCharge,
                waitingTime: this.state.tripDetails.waitTime,
                waitingChargeTotal: this.state.tripDetails.waitTotal,
                extraStopCharge: this.state.tripDetails.stopCharge,
                noOfStops: this.state.tripDetails.noOfStop,
                stopTotal: this.state.tripDetails.noOfStop * this.state.tripDetails.stopCharge,
                meetGreet: this.state.tripDetails.meetGreetCharge,
                mgToPay: this.state.tripDetails.mgPayTo.toString(),
                payMeetGreetId: this.state.tripDetails.meetGreetId,
                payMeetGreetAmount: this.state.tripDetails.meetGreetAmount,
                mgDriverComms: this.state.tripDetails.mgDriverComms == false ? "1" : "2",
                agentCommissionId: this.state.tripDetails.agentName !== "" ? this.state.dropdownAgentCommission.find(opt => opt.name == this.state.tripDetails.agentName).id : 0,
                agentCommissionName: this.state.tripDetails.agentName,
                agentCommissionAmount: this.state.tripDetails.agentCommission,
                discount: this.state.tripDetails.discount,

                portAuthority: this.state.tripDetails.portAuthority,
                utitity: this.state.tripDetails.utilityTax,
                countyTax: this.state.tripDetails.countyTax,
                congestionTax: this.state.tripDetails.congestionTax,
                workCompantation: this.state.tripDetails.wcTax,
                salesTax: this.state.tripDetails.salesTax,
                grossAmount: this.state.tripDetails.grossFare,
                totalFare: this.state.tripDetails.totalFare,
                paidAmount: this.state.tripDetails.totalPaid,

                taxOptionId: this.state.tripDetails.taxInclude.toString(),
                isAppliedPortAuthority: this.state.tripDetails.paApplicable,
                isAppliedSalesTax: this.state.tripDetails.salesTaxApplicable,
                isAppliedCountyTax: this.state.tripDetails.countyTaxApplicable,
                isAppliedCongestionTax: this.state.tripDetails.congestionTaxApplicable,
            });

            if (parseInt(this.state.tripDetails.paymentTypeId) == 2) {

                this.setState({
                    creditCard: "xxxxxxxxxxxx" + this.state.tripDetails.ccNumber,
                    cardExpiry: this.state.tripDetails.ccExp,
                    cardType: this.state.tripDetails.ccType,
                    isLockRates: true,
                })
                CardTypes.forEach((item) => {
                    if (this.state.tripDetails.ccType.trim().match(item.name)) {
                        this.setState({ cardImage: item.image })
                    }
                })
            }
        }
        if (this.state.rateLookup != null) {
            this.setState({
                pickupZoneId: this.state.rateLookup.FromZoneId,
                dropoffZoneId: this.state.rateLookup.ToZoneId,
                vehicleTypeId: this.state.rateLookup.ApiVehicleTypeId,
                isMeetGreet: this.state.rateLookup.IsMgRequired,
                rateId: this.state.rateLookup.RateId,
            })
            this.getRideTypeId(this.state.rateLookup.FromZoneId, this.state.rateLookup.ToZoneId);
            this.getCustomerRateTaxSetting(this.state.rateLookup.FromZoneId, this.state.rateLookup.ToZoneId, this.state.puDateTime, this.state.rateLookup.ApiVehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet)
        }
    }

    handlePickupPlaceSelect() {
        var placeObj = this.handlePlaceSearch(this.autocompletePickup);
        this.state.errors["pickupLocation"] = "";
        if (placeObj !== null) {
            this.setState({
                pickupLocation: placeObj.location,
                pickupAddress: placeObj.address1,
                pickupAddressType: placeObj.addressType,
                pickupCity: placeObj.cityName,
                pickupState: placeObj.stateName,
                pickupZipCode: placeObj.zipCode,
                pickupLatitude: placeObj.latitude,
                pickupLongitude: placeObj.longitude,
            })
        } else {
            this.setState({
                pickupLocation: "",
                pickupAddress: "",
                pickupAddressType: "",
                pickupCity: "",
                pickupState: "",
                pickupZipCode: "",
                pickupLatitude: 0,
                pickupLongitude: 0
            });

        }

    }

    handleDropoffPlaceSelect() {
        var placeObj = this.handlePlaceSearch(this.autocompletePickup);
        this.state.errors["dropoffLocation"] = "";
        if (placeObj !== null) {
            this.setState({
                dropoffLocation: placeObj.location,
                dropoffAddress: placeObj.address1,
                dropoffAddressType: placeObj.addressType,
                dropoffCity: placeObj.cityName,
                dropoffState: placeObj.stateName,
                dropoffZipCode: placeObj.zipCode,
                dropoffLatitude: placeObj.latitude,
                dropoffLongitude: placeObj.longitude,
            })
        } else {
            this.setState({
                dropoffLocation: "",
                dropoffAddress: "",
                dropoffAddressType: "",
                dropoffCity: "",
                dropoffState: "",
                dropoffZipCode: "",
                dropoffLatitude: 0,
                dropoffLongitude: 0
            });

        }

    }

    handlePlaceSearch(autocomplete_place) {
        let place = autocomplete_place.getPlace();

        var placeObject = new Object();

        if (place !== null && place.formatted_address !== null && place.formatted_address.trim() != "") {
            placeObject.location = place.name;
            placeObject.latitude = place.geometry.location.lat();
            placeObject.longitude = place.geometry.location.lng();

            var splitAddress = [];
            place.formatted_address = place.formatted_address.replace(/-/g, ',');
            splitAddress = place.formatted_address.split(',');
            if (splitAddress.length > 0) {
                if (splitAddress.length == 1) {
                    placeObject.address1 = splitAddress[0];
                    placeObject.cityName = "";
                    placeObject.zipCode = "";
                    placeObject.stateName = "";
                    placeObject.countryName = "";
                }
                else if (splitAddress.length == 2) {
                    placeObject.address1 = splitAddress[0];
                    placeObject.cityName = splitAddress[0];
                    placeObject.stateName = splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[0] : splitAddress[1].trim();
                    placeObject.zipCode = splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[1] : " ";
                    placeObject.countryName = "";
                }
                else if (splitAddress.length == 3) {
                    placeObject.address1 = splitAddress[0] + ' ' + splitAddress[1].trim();
                    placeObject.cityName = splitAddress[1].trim();
                    placeObject.stateName = splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[0] : splitAddress[2].trim();
                    placeObject.zipCode = splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[1] : " ";
                    placeObject.countryName = "";
                }
                else if (splitAddress.length == 4) {
                    placeObject.address1 = splitAddress[0] + ' ' + splitAddress[1].trim();
                    placeObject.cityName = splitAddress[1].trim();
                    placeObject.stateName = splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[0] : splitAddress[2].trim();
                    placeObject.zipCode = splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[1] : " ";
                    placeObject.countryName = splitAddress[3].trim();
                }
                else if (splitAddress.length == 5) {
                    placeObject.address1 = splitAddress[0] + ' ' + splitAddress[1].trim() + ' ' + splitAddress[2].trim();
                    placeObject.cityName = splitAddress[2].trim();
                    placeObject.stateName = splitAddress[3].trim().search(' ') > 0 ? splitAddress[3].trim().split(' ')[0] : splitAddress[3].trim();
                    placeObject.zipCode = splitAddress[3].trim().search(' ') > 0 ? splitAddress[3].trim().split(' ')[1] : " ";
                    placeObject.countryName = splitAddress[4].trim();
                }
                else if (splitAddress.length == 6) {
                    placeObject.address1 = splitAddress[0] + ' ' + splitAddress[1].trim() + ' ' + splitAddress[2].trim() + ' ' + splitAddress[3].trim();
                    placeObject.cityName = splitAddress[3].trim();
                    placeObject.stateName = splitAddress[4].trim().search(' ') > 0 ? splitAddress[4].trim().split(' ')[0] : splitAddress[4].trim();
                    placeObject.zipCode = splitAddress[4].trim().search(' ') > 0 ? splitAddress[4].trim().split(' ')[1] : " ";
                    placeObject.countryName = splitAddress[5].trim();
                }
                else {
                    placeObject.address1 = splitAddress[0] + ' ' + splitAddress[1].trim() + ' ' + splitAddress[2].trim() + ' ' + splitAddress[3].trim() + ' ' + splitAddress[4].trim();
                    placeObject.cityName = splitAddress[4].trim();
                    placeObject.stateName = splitAddress[5].trim().search(' ') > 0 ? splitAddress[5].trim().split(' ')[0] : splitAddress[5].trim();
                    placeObject.zipCode = splitAddress[5].trim().search(' ') > 0 ? splitAddress[5].trim().split(' ')[1] : " ";
                    placeObject.countryName = splitAddress[6].trim();
                }
            }
        }
        return placeObject;
    }

    handlePickupToggleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            pickupLocation: "",
            pickupAddress: "",
            pickupAddressType: "",
            pickupCity: "",
            pickupState: "",
            pickupZipCode: "",
            pickupLatitude: 0,
            pickupLongitude: 0
        });
        this.state.errors["pickupLocation"] = "";
        if (value === true) {
            var options = { types: ['establishment'] };
            this.autocompletePickup = new google.maps.places.Autocomplete(document.getElementById('pickupGoogle'), options);
            this.autocompletePickup.addListener("place_changed", this.handlePickupPlaceSelect);
        }

        this.setState({ isPickupGoogleBooking: value })
    }

    handleDropoffToggleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            dropoffLocation: "",
            dropoffAddress: "",
            dropoffAddressType: "",
            dropoffCity: "",
            dropoffState: "",
            dropoffZipCode: "",
            dropoffLatitude: 0,
            dropoffLongitude: 0
        });
        this.state.errors["dropoffLocation"] = "";

        if (value === true) {
            var options = { types: ['establishment'] };
            this.autocompletePickup = new google.maps.places.Autocomplete(document.getElementById('dropoffGoogle'), options);
            this.autocompletePickup.addListener("place_changed", this.handleDropoffPlaceSelect);
        }

        this.setState({ isDropoffGoogleBooking: value })
    }



    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "recurringTypeId") {
            this.setState({
                selectedDays: [],
                isWeekSun: false,
                isWeekMon: false,
                isWeekTue: false,
                isWeekWed: false,
                isWeekThu: false,
                isWeekFri: false,
                isWeekSat: false,
                isMonthSun: false,
                isMonthMon: false,
                isMonthTue: false,
                isMonthWed: false,
                isMonthThu: false,
                isMonthFri: false,
                isMonthSat: false,
            });
            this.setState({
                [name]: value
            });
            this.state.errors["recurring"] = "";
        } else if (name === "serviceSourceId") {
            if (value === "1") {
                this.setState({
                    otherAffiliateId: 0,
                });
            }
            this.setState({
                [name]: value
            });
            this.state.errors[name] = "";
        } else if (name === "paymentTermId") {
            if (value === "2") {
                this.setState({
                    tripTypeId: "1",
                    noOfTrip: 1
                });
            }
            this.setState({
                [name]: value
            });
            this.state.errors[name] = "";
        } else if (name === "creditCard") {
            const re = /^[0-9\b]+$/;
            CardTypes.forEach((item) => {
                if (event.target.value.trim().match(item.pattern)) {
                    this.setState({ cardType: item.name, cardImage: item.image })
                }
            })

            this.setState({ creditCard: event.target.value })
            if (event.target.value === "") {
                this.setState({ cardType: "", cardImage: "" })
            }
            this.state.errors["cardType"] = "";
        } else if (name === "checkNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ checkNumber: event.target.value })
                this.state.errors["checkNumber"] = "";
            }
        } else {
            this.setState({
                [name]: value
            });
            this.state.errors[name] = "";
        }
    }

    async handleRateChange(ctrl, value) {
        if (value == undefined) { value = 0 }
        this.setState({
            [ctrl]: value
        });
        this.state.errors["rideAmount"] = "";
        await this.calculateFare(ctrl, value);
    }


    async calculateFare(ctrl, value) {

        try {
            let paxCount = (parseInt(this.state.noOfPax | 0));

            var newObject = new Object();
            newObject.TripAmt = (ctrl === "rideAmount") ? parseFloat(value) : parseFloat(this.state.rideAmount);
            newObject.TollAmt = (ctrl === "tollAmount") ? parseFloat(value) : parseFloat(this.state.tollAmount);
            newObject.TipAmt = (ctrl === "tipAmount") ? parseFloat(value) : parseFloat(this.state.tipAmount);
            newObject.ExtraAmt = (ctrl === "extraAmount") ? parseFloat(value) : parseFloat(this.state.extraAmount);
            newObject.Misc = (ctrl === "parkingFee") ? parseFloat(value) : parseFloat(this.state.parkingFee);
            newObject.FuelSurCharge = (ctrl === "fuelSurcharge") ? parseFloat(value) : parseFloat(this.state.fuelSurcharge);
            newObject.TourGuideAmt = (ctrl === "tourGuideCharge") ? parseFloat(value) : parseFloat(this.state.tourGuideCharge);
            newObject.MeetGreet = (ctrl === "meetGreet") ? parseFloat(value) : parseFloat(this.state.meetGreet);
            newObject.OT = (ctrl === "otAmount") ? parseFloat(value) : parseFloat(this.state.otAmount);
            newObject.SvcFee = (ctrl === "serviceFeeAmount") ? parseFloat(value) : parseFloat(this.state.serviceFeeAmount);
            newObject.WaitCharge = (ctrl === "waitingCharge") ? parseFloat(value) : parseFloat(this.state.waitingCharge);
            newObject.WaitTime = (ctrl === "waitingTime") ? parseFloat(value) : parseInt(this.state.waitingTime);
            newObject.StopCharge = (ctrl === "extraStopCharge") ? parseFloat(value) : parseFloat(this.state.extraStopCharge);
            newObject.NoOfStop = (ctrl === "noOfStops") ? parseFloat(value) : parseInt(this.state.noOfStops);

            if (this.state.customerRateTax != null) {
                newObject.AgentCommissionPercentage = parseFloat(this.state.customerRateTax.agentCommissionPercentage == null ? 0 : this.state.customerRateTax.agentCommissionPercentage);

                newObject.WcCharge = parseFloat(this.state.customerRateTax.wcTaxCharge);
                newObject.PaCharge = parseFloat(this.state.customerRateTax.paTaxCharge);
                newObject.UtilityCharge = parseFloat(this.state.customerRateTax.utilityTaxCharge);
                newObject.SalesCharge = parseFloat(this.state.customerRateTax.salesTaxCharge);
                newObject.CountyCharge = parseFloat(this.state.customerRateTax.countyTaxCharge);
                newObject.CongestionCharge = parseFloat(this.state.customerRateTax.congestionTaxCharge);
            } else {
                newObject.AgentCommissionPercentage = parseFloat(0);

                newObject.WcCharge = parseFloat(0);
                newObject.PaCharge = parseFloat(0);
                newObject.UtilityCharge = parseFloat(0);
                newObject.SalesCharge = parseFloat(0);
                newObject.CountyCharge = parseFloat(0);
                newObject.CongestionCharge = parseFloat(0);
            }


            if (parseInt(this.state.pickupZoneId) > 0 && parseInt(this.state.dropoffZoneId) > 0 && parseInt(this.state.vehicleTypeId) > 0) {

                var newObjectTaxSetting = new Object();
                newObjectTaxSetting.ApiVehicleTypeId = parseInt(this.state.vehicleTypeId);
                newObjectTaxSetting.FromZoneId = parseInt(this.state.pickupZoneId);
                newObjectTaxSetting.ToZoneId = parseInt(this.state.dropoffZoneId);
                newObjectTaxSetting.IncludedTax = parseInt(this.state.taxOptionId);
                newObjectTaxSetting.IsPaApplicable = this.state.isAppliedPortAuthority;
                newObjectTaxSetting.IsSalesApplicable = this.state.isAppliedSalesTax;
                newObjectTaxSetting.IsCountyApplicable = this.state.isAppliedCountyTax;
                newObjectTaxSetting.IsCongestionApplicable = this.state.isAppliedCongestionTax;

                const requestParamsTaxSetting = getRequestParams('POST', newObjectTaxSetting);
                const responseTaxSetting = await fetch('quotation-api/taxsetting-without-customer', requestParamsTaxSetting);
                const dataTaxSetting = await responseTaxSetting.json();

                newObject.IsWcTax = dataTaxSetting.isBtWc;
                newObject.IsPATax = dataTaxSetting.isBtPa;
                newObject.IsUtilitTax = dataTaxSetting.isBtUtility;
                newObject.IsSalesTax = dataTaxSetting.isBtNySales;
                newObject.IsCountyTax = dataTaxSetting.isBtCounty;
                newObject.IsCongestionTax = dataTaxSetting.isBtCongestion;
                newObject.TaxInclude = newObjectTaxSetting.IncludedTax;


            } else {
                if (this.state.customerRateTax != null) {
                    newObject.IsWcTax = this.state.customerRateTax.allowWorkCommpactionTax;
                    newObject.IsPATax = this.state.customerRateTax.allowPortAuthTax;
                    newObject.IsUtilitTax = this.state.customerRateTax.allowUtilityTax;
                    newObject.IsSalesTax = this.state.customerRateTax.allowSalesTax;
                    newObject.IsCountyTax = this.state.customerRateTax.allowCountyTax;
                    newObject.IsCongestionTax = this.state.customerRateTax.allowCongestionTax;
                    newObject.TaxInclude = this.state.customerRateTax.taxInclude;
                } else {
                    newObject.IsWcTax = false;
                    newObject.IsPATax = false;
                    newObject.IsUtilitTax = false;
                    newObject.IsSalesTax = false;
                    newObject.IsCountyTax = false;
                    newObject.IsCongestionTax = false;
                    newObject.TaxInclude = parseInt(1);
                }

            }
            newObject.Discount = (ctrl === "discount") ? parseFloat(value) : parseFloat(this.state.discount);
            newObject.NoOfPax = parseInt(paxCount);
            if (this.state.customerRateTax != null) {
                newObject.IsCongestionTaxFlatRate = this.state.customerRateTax.isTaxCongestionFlatRate;
                newObject.IsSharedRateApplicable = this.state.customerRateTax.isSharedRateApplicable;
            } else {
                newObject.IsCongestionTaxFlatRate = false;
                newObject.IsSharedRateApplicable = false;
            }
            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('reservation-api/rate-calculation', requestParams);
            const data = await response.json();

            this.setState({
                waitingChargeTotal: parseFloat(data.waitTotal),
                stopTotal: parseFloat(data.stopTotal),

                portAuthority: parseFloat(data.paTax),
                salesTax: parseFloat(data.salesTax),
                utitity: parseFloat(data.utilityTax),
                workCompantation: parseFloat(data.wcTax),
                countyTax: parseFloat(data.countyTax),
                congestionTax: parseFloat(data.congestionTax),

                grossAmount: parseFloat(data.grossFare),
                totalFare: parseFloat(data.totalFare)
            });

            if (parseFloat(data.agentCommissionAmount) > 0) {
                this.setState({
                    agentCommissionAmount: parseFloat(data.agentCommissionAmount)
                });
            }

            if (this.state.quoteId > 0) {
                if (this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')) {
                    //no change total paid.

                } else if ((this.state.paymentTypeId === 2 && !this.state.creditCard.includes('x')) || this.state.paymentTypeId === 3) {
                    this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: 1 });
                } else {
                    if (parseInt(this.state.paymentTermId) == 1) {
                        this.setState({ paidAmount: parseFloat(0).toFixed(3) });
                    }
                }

            } else {
                if (this.state.paymentTypeId === 2 || this.state.paymentTypeId === 3) {
                    this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: 1 });
                } else {
                    this.setState({ paidAmount: parseFloat(0).toFixed(3) });
                }
            }


        } catch (e) {
            console.log(e);
        }
    }

    handlePickupZoneChange(selectedOption) {

        this.setState({ pickupZoneId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["pickupZoneId"] = "";
        (selectedOption.selectedItem != null && this.getRideTypeId(selectedOption.selectedItem.id, this.state.dropoffZoneId));

        (selectedOption.selectedItem != null && this.getCustomerRateTaxSetting(selectedOption.selectedItem.id, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet));
    }
    handleDropoffZoneChange(selectedOption) {
        this.setState({ dropoffZoneId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["dropoffZoneId"] = "";
        (selectedOption.selectedItem != null && this.getRideTypeId(this.state.pickupZoneId, selectedOption.selectedItem.id));

        (selectedOption.selectedItem != null && this.getCustomerRateTaxSetting(this.state.pickupZoneId, selectedOption.selectedItem.id, this.state.puDateTime, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet));
    }
    handleAirlineChange(selectedOption) {
        this.setState({ airlineId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.airLineId : 0), })
    }
    handleAirlineReturnChange(selectedOption) {
        this.setState({ airlineIdReturn: (selectedOption.selectedItem != null ? selectedOption.selectedItem.airLineId : 0), })
        this.state.errors["airlineIdReturn"] = "";
    }
    handleVehicleTypeChange(selectedOption) {
        this.setState({ vehicleTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.rowIndex : 0), })
        this.state.errors["vehicleTypeId"] = "";

        (selectedOption.selectedItem != null && this.getCustomerRateTaxSetting(this.state.pickupZoneId, this.state.dropoffZoneId, this.state.puDateTime, selectedOption.selectedItem.rowIndex, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet));
    }
    handleAffiliateChange(selectedOption) {
        this.setState({ otherAffiliateId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["otherAffiliateId"] = "";
    }

    handleReservationModeChange(selectedOption) {
        this.setState({ reservationModeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["reservationModeId"] = "";
    }

    handleMgToPay(e) {
        this.setState({
            mgToPay: e.target.value
        });
        this.setState({ payMeetGreetId: 0, payMeetGreetAmount: 0.000 })
    }

    handleDriverCommissionPay(e) {
        this.setState({
            mgDriverComms: e.target.value
        });
    }

    handleGreeterChange(selectedOption) {
        this.setState({ payMeetGreetId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["payMeetGreetId"] = "";
    }

    handleAgentCommissionChange(selectedOption) {
        this.setState({ agentCommissionId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
    }

    handlePaymentTypeChange(selectedOption) {
        this.setState({ paymentTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })

        this.setState({
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            existingCardId: 0,
            creditCard: "",
            cardType: "",
            cardExpiry: "",
            voucherCompanyId: 0,
            voucherCode: "",
        });
        this.state.errors["checkNumber"] = "";
        this.state.errors["checkBank"] = "";
        this.state.errors["checkDate"] = "";
        this.state.errors["existingCardId"] = "";
        this.state.errors["creditCard"] = "";
        this.state.errors["cardType"] = "";
        this.state.errors["cardExpiry"] = "";
        this.state.errors["voucherCompanyId"] = "";
        this.state.errors["voucherCode"] = "";

        var paytypeId = (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0);

        if (this.state.quoteId > 0) {
            if (paytypeId === 2 && this.state.creditCard.includes('x')) {
                //no change total paid.

            } else if ((paytypeId === 2 && !this.state.creditCard.includes('x')) || paytypeId === 3) {
                this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: 1 });
            } else {
                this.setState({ paidAmount: parseFloat(0).toFixed(3) });
            }

        } else {
            if (paytypeId === 2 || paytypeId === 3) {
                this.setState({ paidAmount: parseFloat(this.state.totalFare).toFixed(3), paymentTermId: 1 });
            } else {
                this.setState({ paidAmount: parseFloat(0).toFixed(3) });
            }
        }
    }

    handleVoucherCompanyChange(selectedOption) {
        this.setState({ voucherCompanyId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["voucherCompanyId"] = "";
    }

    handleExistingCardChange(selectedOption) {
        this.setState({ existingCardId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["existingCardId"] = "";
    }

    handleRecurringEndDateChange(date) {
        this.setState({ recurringEndDate: date.value });
        this.state.errors["recurringEndDate"] = "";
    }

    handleFlightDateTimeChange(date) {
        this.setState({ flightTime: date });
        this.state.errors["flightTime"] = "";
    }

    handleFlightDateTimeReturnChange(date) {
        this.setState({ flightTimeReturn: date });
        this.state.errors["flightTimeReturn"] = "";
    }

    handlePickupDateTimeChange(date) {
        this.setState({ puDateTime: date.value });
        this.state.errors["puDateTime"] = "";

        (date != null && this.getCustomerRateTaxSetting(this.state.pickupZoneId, this.state.dropoffZoneId, date, this.state.vehicleTypeId, parseInt(this.state.noOfPax | 0), 0, this.state.isMeetGreet));
    }

    handlePickupDateTimeReturnChange(date) {
        this.setState({ puDateTimeReturn: date.value });
        this.state.errors["puDateTimeReturn"] = "";
    }

    handlePaxCountChange(value) {
        this.setState({ noOfPax: value });
        this.getCustomerRateTaxSetting(this.state.pickupZoneId, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, value, 0, this.state.isMeetGreet);
        if (value > 0) {
            this.state.errors["noOfPax"] = ""
        }
    }

    handlePaxCountReturnChange(value) {
        this.setState({ noOfPaxReturn: value });
    }

    handleTripTypeChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ tripTypeId: value });

        this.setState({
            recurringTypeId: 2,
            selectedDays: [],
            recurringEndDate: "",
            isWeekSun: false,
            isWeekMon: false,
            isWeekTue: false,
            isWeekWed: false,
            isWeekThu: false,
            isWeekFri: false,
            isWeekSat: false,
            isMonthSun: false,
            isMonthMon: false,
            isMonthTue: false,
            isMonthWed: false,
            isMonthThu: false,
            isMonthFri: false,
            isMonthSat: false,
        });
        this.state.errors["recurring"] = "";

        this.setState({
            flightNumberReturn: "",
            terminalTypeReturn: "",
            terminalReturn: "",
            noOfPaxReturn: 1,
            noOfTrip: 1
        });

        this.state.errors["airlineIdReturn"] = "";
        this.state.errors["flightNumberReturn"] = "";
        this.state.errors["noOfPaxReturn"] = "";
        this.state.errors["flightTimeReturn"] = "";
        this.state.errors["puDateTimeReturn"] = "";
    }

    handleTaxOptionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "exempted" || name === "addToFare" || name === "includedInFare") {
            this.setState({
                taxOptionId: value,
            });
            if (name === "exempted") {
                this.setState({
                    isAppliedPortAuthority: false,
                });
            }

        } else {
            this.setState({
                [name]: value,
            });
        }

        let myVar = setTimeout(() => this.calculateFare("", 0), 500)
    }

    handleMeetGreetChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ isMeetGreet: value, meetGreet: 0 });
        if (value == false) {
            this.setState({ meetGreet: 0 });
            this.calculateFare("meetGreet", 0);
        }
        let paxCount = (parseInt(this.state.noOfPax | 0));
        this.getCustomerRateTaxSetting(this.state.pickupZoneId, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, paxCount, 0, value);
    }

    handleValidation() {        
        let errors = this.state.errors;
        let formIsValid = true;
        errors.paxFirstName = "";
        errors.paxLastName = "";
        errors.countryCode = "";
        errors.mobileNumber = "";
        errors.email = "";
        errors.pickupLocation = "";
        errors.pickupZoneId = "";
        errors.dropoffLocation = "";
        errors.dropoffZoneId = "";
        errors.otherAffiliateId = "";
        errors.puDateTime = "";
        errors.puDateTimeReturn = "";
        errors.doDateTime = "";
        errors.flightTime = "";
        errors.flightNumber = "";
        errors.terminalType = "";
        errors.flightTimeReturn = "";
        errors.flightNumberReturn = "";
        errors.terminalTypeReturn = "";
        errors.noOfPaxReturn = "";
        errors.orderByName = "";
        errors.reservationModeId = "";
        errors.vehicleTypeId = "";
        errors.noOfTrip = "";
        errors.noOfPax = "";
        errors.recurringEndDate = "";
        errors.recurring = "";
        errors.rideAmount = "";
        errors.payMeetGreetId = "";
        errors.payMeetGreetAmount = "";

        errors.paymentTypeId = "";
        errors.paidAmount = "";
        errors.checkNumber = "";
        errors.checkBank = "";
        errors.checkDate = "";
        errors.existingCardId = "";
        errors.creditCard = "";
        errors.cardType = "";
        errors.cardExpiry = "";
        errors.voucherCompanyId = "";
        errors.voucherCode = "";

        if (this.state.paxFirstName.trim() === '') {
            formIsValid = false;
            errors.paxFirstName = "Please enter pax first name.";
        }
        if (this.state.paxLastName.trim() === '') {
            formIsValid = false;
            errors.paxLastName = "Please enter pax last name.";
        }
        if (this.state.mobileNumber.trim() === "") {
            formIsValid = false;
            errors.mobileNumber = "Please enter mobile.";
        } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length != 10) {
            formIsValid = false;
            errors.mobileNumber = "Invalid mobile number.";
        }
        if (this.state.countryCode.trim() == '') {
            formIsValid = false;
            errors.countryCode = "Required.";
        }
        if (this.state.isSendEmail == true && this.state.email.trim() === "") {
            formIsValid = false;
            errors.email = "Please enter email.";
        }
        if (this.state.email.trim() != "") {
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!regEmail.test(this.state.email)) {
                formIsValid = false;
                errors.email = "Please enter valid email.";
            }
        }
        if (this.state.pickupLocation.trim() === '') {
            formIsValid = false;
            errors.pickupLocation = "Please enter pick-up location.";
        }
        if (this.state.pickupZoneId == 0) {
            formIsValid = false;
            errors.pickupZoneId = "Please select pick-up zone.";
        }
        if (this.state.dropoffLocation.trim() === '') {
            formIsValid = false;
            errors.dropoffLocation = "Please enter drop off location.";
        }
        if (this.state.dropoffZoneId == 0) {
            formIsValid = false;
            errors.dropoffZoneId = "Please select drop off zone.";
        }
        if (this.state.puDateTime == null) {
            formIsValid = false;
            errors.puDateTime = "Please enter pick-up date time.";
        }
        if (this.state.doDateTime == '') {
            formIsValid = false;
            errors.puDateTime = "Please enter drop off date time.";
        }
        if (this.state.airlineId > 0) {
            if (this.state.flightNumber.trim() === '') {
                formIsValid = false;
                errors.flightNumber = "Please enter flight #.";
            }
            if (this.state.flightTime == null) {
                formIsValid = false;
                errors.flightTime = "Please enter flight time.";
            }
        }

        if (this.state.tripTypeId === "2") {
            if (this.state.airlineIdReturn > 0) {
                if (this.state.flightNumberReturn.trim() === '') {
                    formIsValid = false;
                    errors.flightNumberReturn = "Please enter flight #.";
                }
                if (this.state.flightTimeReturn == null) {
                    formIsValid = false;
                    errors.flightTimeReturn = "Please enter flight time.";
                }
            }

            if (this.state.puDateTimeReturn == null) {
                formIsValid = false;
                errors.puDateTimeReturn = "Please enter pick-up date time.";
            }

            if (parseInt(this.state.noOfPaxReturn | 0) == 0) {
                formIsValid = false;
                errors.noOfPaxReturn = "Please enter no of pax.";
            }
        }

        if (this.state.orderByName.trim() === '') {
            formIsValid = false;
            errors.orderByName = "Please enter order by.";
        }
        if (this.state.reservationModeId == 0) {
            formIsValid = false;
            errors.reservationModeId = "Please select rez mode.";
        }
        if (this.state.vehicleTypeId == 0) {
            formIsValid = false;
            errors.vehicleTypeId = "Please select vehicle type.";
        }
        if (parseInt(this.state.noOfTrip | 0) == 0) {
            formIsValid = false;
            errors.noOfTrip = "Please enter no. of trip.";
        }
        if (parseInt(this.state.noOfPax | 0) == 0) {
            formIsValid = false;
            errors.noOfPax = "Please enter no. of trip.";
        }
        if (this.state.serviceSourceId == 2 || this.state.serviceSourceId == 3) {
            if (this.state.otherAffiliateId == 0) {
                formIsValid = false;
                errors.otherAffiliateId = "Please select affiliate.";
            }
        }

        if (this.state.tripTypeId === "3") {

            if (this.state.recurringEndDate === "" || this.state.recurringEndDate === null) {
                formIsValid = false;
                errors.recurringEndDate = "Please enter recurring end date.";
            }

            if (this.state.recurringTypeId == 1) {
                if (this.state.selectedDays.length === 0) {
                    formIsValid = false;
                    errors.recurring = "Please select recurring days.";
                }
            }

            if (this.state.recurringTypeId == 2) {
                if (this.state.isWeekSun === false &&
                    this.state.isWeekMon === false &&
                    this.state.isWeekTue === false &&
                    this.state.isWeekWed === false &&
                    this.state.isWeekThu === false &&
                    this.state.isWeekFri === false &&
                    this.state.isWeekSat === false) {
                    formIsValid = false;
                    errors.recurring = "Please select recurring days.";
                }
            }

            if (this.state.recurringTypeId == 3) {
                if (this.state.isMonthSun === false &&
                    this.state.isMonthMon === false &&
                    this.state.isMonthTue === false &&
                    this.state.isMonthWed === false &&
                    this.state.isMonthThu === false &&
                    this.state.isMonthFri === false &&
                    this.state.isMonthSat === false) {
                    formIsValid = false;
                    errors.recurring = "Please select recurring days.";
                }
            }
        }



        if (this.state.paymentTypeId === 0) {
            formIsValid = false;
            errors.paymentTypeId = "Please select payment type.";
        }

        if (this.state.paymentTypeId === 2) {
            if (this.state.creditCard.trim() === "") {
                formIsValid = false;
                errors.creditCard = "Please select or enter card.";
            }

            if (this.state.cardType === "") {
                formIsValid = false;
                errors.cardType = "Please select card type.";
            }

            if (this.state.cardExpiry === "") {
                formIsValid = false;
                errors.cardExpiry = "Please enter card expiry.";
            }
        }

        if (this.state.paymentTypeId === 4) {
            if (this.state.checkNumber === "") {
                formIsValid = false;
                errors.checkNumber = "Please enter check number.";
            }

            if (this.state.checkBank === "") {
                formIsValid = false;
                errors.checkBank = "Please enter bank name.";
            }

            if (this.state.checkDate === "") {
                formIsValid = false;
                errors.checkDate = "Please enter check date.";
            }
        }

        if (this.state.paymentTypeId === 7) {
            if (this.state.voucherCompanyId === 0) {
                formIsValid = false;
                errors.voucherCompanyId = "Please select company.";
            }

            if (this.state.voucherCode === "") {
                formIsValid = false;
                errors.voucherCode = "Please enter voucher.";
            }
        }

        if (parseFloat(this.state.rideAmount) === 0) {
            formIsValid = false;
            errors.rideAmount = "Please enter ride amt.";
        }


        if (parseInt(this.state.mgToPay) === 1) {
            if (this.state.payMeetGreetId === 0) {
                formIsValid = false;
                errors.payMeetGreetId = "Please select Greeter.";
            }

            if (parseFloat(this.state.payMeetGreetAmount) === 0) {
                formIsValid = false;
                errors.payMeetGreetAmount = "Please enter greeter amt.";
            }
        }
        if (parseInt(this.state.paymentTypeId) === 2 || parseInt(this.state.paymentTypeId) === 3) {
            if (parseFloat(this.state.paidAmount) === 0) {
                formIsValid = false;
                errors.paidAmount = "Please enter paid amt.";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    async checkDuplicateReservation(isButtonShow) {
        let isResult = false;
        var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        var pickupdate = ((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear();

        if (this.state.paxFirstName.trim() == "") {
            this.state.errors["paxFirstName"] = "Please enter first name."
            return;
        }

        if (this.state.paxLastName.trim() == "") {
            this.state.errors["paxLastName"] = "Please enter last name."
            return;
        }

        var newObject = new Object();
        newObject.CustomerId = 0;
        newObject.FirstName = this.state.paxFirstName;
        newObject.LastName = this.state.paxLastName;
        newObject.FromDate = pickupdate + " 00:00";
        newObject.ToDate = pickupdate + " 23:59";

        try {
            if (isButtonShow == false) {
                this.props.duplicateFunction(true);
            }
            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('reservation-api/duplicate-list', requestParams);
            const data = await response.json();

            if (data.duplicateTrips.length > 0) {
                this.props.duplicateFunction(false);

                const isValid = await Swal.fire({
                    title: "<small>Duplicate trips</small>",
                    text: "Duplicate trip(s) found!",
                    icon: "success",
                    width: '25%',
                    dangerMode: false,
                    allowOutsideClick: false
                });

                this.refs.duplicationReservationModal.showModal(data.duplicateTrips, isButtonShow);
                isResult = true;
            } else {

                if (isButtonShow == false) {

                    this.props.duplicateFunction(false);
                    const isValid = await Swal.fire({
                        title: "<small>Duplicate trips</small>",
                        text: "Duplicate trip(s) not found!",
                        icon: "success",
                        width: '25%',
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                }

            }
            return isResult;
        } catch (e) {
            console.log(e);
        }
    }

    async askDuplicateConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Duplicate trips</small>",
            html: "Duplicate trip(s) found.<br> Do you want to continue ..... ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async askScheduleTimeConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "Pickup time should be minimum 10 minutes less than schedule time!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async askReturnTripConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "You are going book a return trip quote!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async askBookingConfirm(paxCount) {
        let isResult = false;
        let strAlert = "";
        strAlert = (strAlert + ("Please Let me confirm your quotation." + ("<br>" + ("<br>" + ("You have a ["
            + (this.state.puDateTime.toLocaleTimeString() + ("] pickup on ["
                + (this.state.puDateTime.toLocaleDateString() + ("]" + ("<br>" + ('\t' + ("From the ["
                    + ((((this.state.pickupLocation.Length) <= 0) ? "" : this.state.pickupLocation) + ("] " + ("<br>" + ("for a total of ["
                        + (paxCount + ("] passanger(s) " + ("<br>" + ('\t' + ("going to ["
                            + (this.state.dropoffLocation + ("]" + ("<br>" + ("\r\n" + ("SPECIAL INSTRUCTION: "
                                + (this.state.specialInstruction + ("<br>" + "Is this Correct?"))))))))))))))))))))))))))));

        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: strAlert,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }


    async handleQuoteSubmit() {
        if (!this.handleValidation()) {            
            return;
        }

        if (this.state.quoteId > 0) {
            if (parseInt(this.state.tripDetails.tripStatusId) == 116) {

                if (parseInt(this.state.tripDetails.invoiceNo) > 0) {
                    const isValid = await Swal.fire({
                        title: "<small>Unable to modify</small>",
                        text: "Reservation is completed & invoiced, you cant modify/update Reservation.",
                        icon: "info",
                        dangerMode: false,
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else {
                    if (parseInt(window.sessionStorage.getItem("session_userTypeId")) == 33
                        || parseInt(window.sessionStorage.getItem("session_userTypeId")) == 6
                        || parseInt(window.sessionStorage.getItem("session_userTypeId")) == 2) {

                    } else {
                        const isValid = await Swal.fire({
                            title: "<small>Unable to modify</small>",
                            text: "Reservation is completed, you cant modify/update Reservation.",
                            icon: "info",
                            dangerMode: false,
                            width: "25%",
                            dangerMode: false,
                            allowOutsideClick: false
                        });
                        return;
                    }
                }
            }

            if (parseInt(this.state.tripDetails.tripStatusId) == 111 || parseInt(this.state.tripDetails.tripStatusId) == 118) {
                const isValid = await Swal.fire({
                    title: "<small>Unable to modify</small>",
                    text: "Reservation is void/cancelled, you cant modify/update Reservation.",
                    icon: "info",
                    dangerMode: false,
                    width: "25%",
                    dangerMode: false,
                    allowOutsideClick: false
                });
                return;
            }
        }

        //if (parseInt(this.state.customer.accountStatusId) == 2) {
        //    const isValid = await Swal.fire({
        //        title: "<small>Account on hold</small>",
        //        text: "This account is on hold. You are not allow to book any reservation. <br>Please contact to accounting department.",
        //        icon: "info",
        //        dangerMode: false,
        //        width: "25%",
        //        dangerMode: false,
        //        allowOutsideClick: false
        //    });
        //    return;
        //}// On Hold

        //if (parseInt(this.state.customer.accountStatusId) == 3) {
        //    const isValid = await Swal.fire({
        //        title: "<small>Account on close</small>",
        //        text: "This account is on close. You are not allow to book any reservation. <br>Please contact to accounting department.",
        //        icon: "info",
        //        dangerMode: false,
        //        width: "25%",
        //        dangerMode: false,
        //        allowOutsideClick: false
        //    });
        //    return;
        //}// On Hold

        //Schedule Validation
        if (this.state.quoteId > 0) {
            if (parseInt(this.state.tripDetails.tripStatusId) == 101
                || parseInt(this.state.tripDetails.tripStatusId) == 103
                || parseInt(this.state.tripDetails.tripStatusId) == 105) {

                if (rideTypeId == 2 && this.state.airlineId > 0) {
                    let diffInMs = Math.abs(this.state.puDateTime - new Date(this.state.puDateTime.toLocaleDateString() + " " + this.state.flightTime.toLocaleTimeString()));
                    let minuteDiff = diffInMs / (1000 * 60);

                    if (minuteDiff <= 0 || minuteDiff < 10) {
                        const isConfirm = await this.askScheduleTimeConfirm();
                        if (!isConfirm) {
                            return;
                        }
                    }
                }
            }
        } else {
            if (rideTypeId == 2 && this.state.airlineId > 0) {
                let diffInMs = Math.abs(this.state.puDateTime - new Date(this.state.puDateTime.toLocaleDateString() + " " + this.state.flightTime.toLocaleTimeString()));
                let minuteDiff = diffInMs / (1000 * 60);

                if (minuteDiff <= 0 || minuteDiff < 10) {
                    const isConfirm = await this.askScheduleTimeConfirm();
                    if (!isConfirm) {
                        return;
                    }
                }
            }
        }



        let paxCount = (parseInt(this.state.noOfPax | 0));
        //Pax count validation.
        let vehicleDetails = this.state.dropdownVehicleType.find(opt => opt.rowIndex == this.state.vehicleTypeId);
        if (paxCount > vehicleDetails.apiPaxNumber) {
            const isValid = await Swal.fire({
                title: "<small>Invalid Pax Count</small>",
                text: "Please enter pax count less than or equal to " + vehicleDetails.apiPaxNumber + " for " + vehicleDetails.apiVehicleTypeDescription + "!",
                icon: "info",
                dangerMode: false,
                width: "25%",
                allowOutsideClick: false
            });
            return;
        }
        //Customer Setting Validation.
        if (this.state.customerRateTax == null) {
            await this.getCustomerRateTaxSetting(this.state.pickupZoneId, this.state.dropoffZoneId, this.state.puDateTime, this.state.vehicleTypeId, paxCount, 0, this.state.isMeetGreet)
        }

        if (this.state.customerRateTax == null) {
            const isValid = await Swal.fire({
                title: "<small>Oops..</small>",
                text: "Customer setting not found!",
                icon: "info",
                dangerMode: false,
                width: "25%",
                allowOutsideClick: false
            });
            return;
        }

        if (parseInt(this.state.paymentTermId) == 2) {

            if (this.state.quoteId <= 0) {
                if (this.state.paymentTypeId !== 2 && this.state.paymentTypeId !== 3) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please select payment type Credit Card Or Cash for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) > parseFloat(this.state.totalFare)) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount less than total fare for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) < 0) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount less than total fare for partial payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) == parseFloat(this.state.totalFare)) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        html: "Full paid amount is not allowed under partial payment section.<Br>Please select 'Paid In Full' option under payment term!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    this.setState({ isSubmited: false });
                    return;
                }
            }

        } else {
            if (this.state.paymentTypeId === 2 || this.state.paymentTypeId === 3) {
                if (parseFloat(this.state.paidAmount) > parseFloat(this.state.totalFare)) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount equal to total fare for full payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                } else if (parseFloat(this.state.paidAmount) < 0) {
                    const isValid = await Swal.fire({
                        title: "<small>Payment Type</small>",
                        text: "Please enter paid amount equal to total fare for full payment!",
                        icon: "info",
                        width: "25%",
                        dangerMode: false,
                        allowOutsideClick: false
                    });
                    return;
                }
            }
        }

        if ((this.state.quoteId > 0) && (this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')) && (parseFloat(this.state.totalFare) > parseFloat(this.state.paidAmount))) {
            let strAlert = "";
            strAlert = (strAlert + ("This ride is already charged by credit card.<br> "
                + "Paid Amount: $" + parseFloat(this.state.paidAmount).toString() + ".<br>"
                + "Additional Chargable Amount: $" + parseFloat(parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount)).toFixed(2).toString() + ".<br><br>"
                + "Already paid amount will be converted in partial payment and overdue amount will be billed under On Account."));

            const isValid = await Swal.fire({
                title: "<small>Overdue Amount</small>",
                html: strAlert,
                icon: "info",
                width: "25%",
                dangerMode: false,
                allowOutsideClick: false
            });
        }

        if (this.state.tripTypeId == "2") {
            const isConfirm = await this.askReturnTripConfirm();
            if (!isConfirm) {
                return;
            }
        }

        const isBookingConfirm = await this.askBookingConfirm(paxCount);
        if (!isBookingConfirm) {
            return;
        }

        this.setState({ isSubmited: true });
        await this.bookReservation();

        //if (this.state.quoteId > 0) {
        //    this.props.submitFunction(true);
        //    await this.bookReservation();
        //} else {
        //    this.props.submitFunction(true);
        //    //Duplicate reservation check.
        //    const isDuplicateFound = await this.checkDuplicateReservation(true);
        //    if (isDuplicateFound) {
        //        this.props.submitFunction(false);
        //    } else {
        //        await this.bookReservation();
        //    }
        //}
    }

    async bookReservation() {
        let paxCount = (parseInt(this.state.noOfPax | 0));

        var pickupDate = [];
        if (this.state.tripTypeId === "3") {
            pickupDate = this.getRecurringPuDateArrayList();

        } else if (this.state.tripTypeId === "2") {
            var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
            pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
        } else {
            for (var tripNo = 0; tripNo < parseInt(this.state.noOfTrip); tripNo++) {
                var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
                pickupDate.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
            }
        }

        if (pickupDate.length <= 0) {
            const isValid = await Swal.fire({
                title: "<small>Date Range</small>",
                text: "Selected days are not between pickup date and end date!",
                icon: "info",
                width: "25%",
                dangerMode: false,
                allowOutsideClick: false
            });
            this.setState({ isSubmited: false });
            return;
        }



        //Get Ride Type Zone Ids.
        let fromAreaId = 0, toAreaId = 0, pickupLocationType = "", dropoffLocationType = "";

        let puZone = this.state.dropdownZone.find(opt => opt.id == this.state.pickupZoneId);
        let doZone = this.state.dropdownZone.find(opt => opt.id == this.state.dropoffZoneId);

        if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
            fromAreaId = puZone.airportId;
            toAreaId = doZone.id;
            pickupLocationType = "AIRPORT";
            dropoffLocationType = "HOTEL";

        } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
            fromAreaId = puZone.id;
            toAreaId = doZone.airportId;
            pickupLocationType = "HOTEL";
            dropoffLocationType = "AIRPORT";
        } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
            fromAreaId = puZone.airportId;
            toAreaId = doZone.airportId;
            pickupLocationType = "AIRPORT";
            dropoffLocationType = "AIRPORT";
        } else {
            fromAreaId = puZone.id;
            toAreaId = doZone.id;
            pickupLocationType = "HOTEL";
            dropoffLocationType = "HOTEL";
        }

        var newObject = new Object();
        newObject.quotationId = this.state.quoteId <= 0 ? 0 : this.state.tripDetails.quotationId;
        newObject.quoteId = this.state.quoteId;

        newObject.rideTypeId = rideTypeId;
        newObject.fromAreaId = fromAreaId;
        newObject.toAreaId = toAreaId;
        newObject.paxCount = paxCount;
        newObject.paxCountReturn = 0;
        newObject.baggage = this.state.luggage;

        newObject.firstName = this.state.paxFirstName;
        newObject.lastName = this.state.paxLastName;
        newObject.firstNameReturn = "";
        newObject.lastNameReturn = "";

        if (parseInt(this.state.tripTypeId) == 2) {
            let paxCountReturn = (parseInt(this.state.noOfPaxReturn | 0));

            newObject.firstNameReturn = this.state.paxLastName;
            newObject.lastNameReturn = this.state.paxLastName;
            newObject.paxCountReturn = paxCountReturn;
        }

        newObject.countryCode = this.state.countryCodePhone;
        newObject.phoneNo = this.state.phoneNumber;
        newObject.cellCountryCode = this.state.countryCode;
        newObject.mobileNo = this.state.mobileNumber;

        newObject.customerId = 0;
        newObject.airlineId = this.state.airlineId != null ? parseInt(this.state.airlineId) : 0;
        newObject.flightNumber = this.state.flightNumber;
        newObject.flightTime = this.state.flightTime.toLocaleTimeString();
        newObject.terminalType = this.state.terminalType != "" ? parseInt(this.state.terminalType) : 0;
        newObject.terminal = this.state.terminal;
        newObject.airlineIdReturn = this.state.airlineIdReturn != null ? parseInt(this.state.airlineIdReturn) : 0;
        newObject.flightNumberReturn = this.state.flightNumberReturn;
        newObject.flightTimeReturn = this.state.flightTimeReturn.toLocaleTimeString();
        newObject.terminalTypeReturn = this.state.terminalTypeReturn != "" ? parseInt(this.state.terminalTypeReturn) : 0;
        newObject.terminalReturn = this.state.terminalReturn;
        newObject.email = this.state.email;
        newObject.poNumber = this.state.poNumber;
        newObject.isPickupGoogleBooking = this.state.isPickupGoogleBooking;
        newObject.pickupLocation = this.state.pickupLocation;
        newObject.pickupLocationType = pickupLocationType;
        newObject.pickupAddress = this.state.pickupAddress;
        newObject.pickupCity = this.state.pickupCity;
        newObject.pickupState = this.state.pickupState;
        newObject.pickupZipCode = this.state.pickupZipCode;
        newObject.pickupLatitude = this.state.pickupLatitude;
        newObject.pickupLongitude = this.state.pickupLongitude;
        newObject.pickupGeoZoneId = puZone.id;
        newObject.pickupIsHotel = puZone.zoneTypeId === 3 ? true : false;

        newObject.isDropoffGoogleBooking = this.state.isDropoffGoogleBooking;
        newObject.dropoffLocation = this.state.dropoffLocation;
        newObject.dropoffLocationType = dropoffLocationType;
        newObject.dropoffAddress = this.state.dropoffAddress;
        newObject.dropoffCity = this.state.dropoffCity;
        newObject.dropoffState = this.state.dropoffState;
        newObject.dropoffZipCode = this.state.dropoffZipCode;
        newObject.dropoffLatitude = this.state.dropoffLatitude;
        newObject.dropoffLongitude = this.state.dropoffLongitude;
        newObject.dropoffGeoZoneId = doZone.id;
        newObject.dropoffIsHotel = doZone.zoneTypeId === 3 ? true : false;

        newObject.apt = this.state.apt;

        newObject.serviceSourceId = parseInt(this.state.serviceSourceId);
        newObject.serviceSourceName = (parseInt(this.state.serviceSourceId) == 1) ? "In House" : ((parseInt(this.state.serviceSourceId) == 2) ? "Farm In" : "Farm Out");
        newObject.otherAffiliateId = parseInt(this.state.otherAffiliateId);
        newObject.isVipTrip = this.state.isVipTrip;
        newObject.isMeetGreet = this.state.isMeetGreet;
        newObject.isAccessible = this.state.isAccessible;
        newObject.isPriority = this.state.isPriorityTrip;
        newObject.pickupDateArray = pickupDate;
        newObject.pickupTime = this.state.puDateTime.toLocaleTimeString();
        newObject.pickupTimeReturn = this.state.puDateTimeReturn.toLocaleTimeString();
        newObject.pickupDateReturn = this.state.puDateTimeReturn.toLocaleDateString();
        newObject.apiVehicleTypeId = parseInt(this.state.vehicleTypeId);
        newObject.tripTypeId = parseInt(this.state.tripTypeId);
        newObject.specialInstruction = this.state.specialInstruction;
        newObject.permanentRemark = this.state.permanentRemark;
        newObject.pickupNotes = this.state.pickupNotes;
        newObject.billToNotes = this.state.billToNotes;

        newObject.orderByName = this.state.orderByName;
        newObject.orderByCountryCode = this.state.countryCodeOrderPhone;
        newObject.orderByPhone = this.state.phoneNumberOrder;
        newObject.orderByEmail = this.state.emailOrder;
        newObject.approxDropoffTime = this.state.doDateTime;
        newObject.approxTripDurationMin = parseInt(this.state.tripDuration);
        newObject.reservationModeId = parseInt(this.state.reservationModeId);

        newObject.pilotCount = 0;
        newObject.crewCount = 0;
        newObject.flightAttandCount = 0;
        newObject.pilotCountReturn = 0;
        newObject.crewCountReturn = 0;
        newObject.flightAttandCountReturn = 0;

        newObject.rateId = this.state.customerRateTax.rateId;
        newObject.paymentTypeId = parseInt(this.state.paymentTypeId);
        newObject.partialPay = parseInt(this.state.paymentTermId) === 1 ? false : true;

        newObject.voucherNo = parseInt(this.state.paymentTypeId) == 7 ? this.state.voucherCode : "";
        newObject.voucherCompany = parseInt(this.state.paymentTypeId) == 7 ? parseInt(this.state.voucherCompanyId) : 0;
        newObject.chqBankName = this.state.checkBank;
        newObject.chqNumber = this.state.checkNumber;
        newObject.chqDate = this.state.checkDate;

        newObject.creditCardNumber = parseInt(this.state.paymentTypeId) == 2 ? this.state.creditCard : "";
        newObject.creditCardExpiry = parseInt(this.state.paymentTypeId) == 2 ? this.state.cardExpiry : "";
        newObject.cardType = parseInt(this.state.paymentTypeId) == 2 ? this.state.cardType : "";

        newObject.transferTypeId = this.state.customerRateTax.transferTypeId;
        newObject.serviceTypeId = this.state.customerRateTax.serviceTypeId;

        newObject.rideAmount = parseFloat(this.state.rideAmount);
        newObject.tollAmnt = parseFloat(this.state.tollAmount);
        newObject.tipAmnt = parseFloat(this.state.tipAmount);
        newObject.meetGreetCharge = parseFloat(this.state.meetGreet);
        newObject.payToTourGuide = parseFloat(this.state.payToTourGuide);
        newObject.tourGuideName = "";
        newObject.tourGuideCharge = parseFloat(this.state.tourGuideCharge);
        newObject.mgPayTo = parseInt(this.state.mgToPay); // 1 => Pay To Greeter, 2 => 100% to Company, 3 => Pay to Driver;
        newObject.meetGreetId = parseInt(this.state.payMeetGreetId);
        newObject.meetGreetName = "";
        newObject.meetGreetAmount = parseFloat(this.state.payMeetGreetAmount);
        newObject.mgDriverComms = (parseInt(this.state.mgToPay) == 3) ? ((this.state.mgDriverComms === "1") ? false : true) : false; // (mgDriverComms) 1 => PayToDriver100% Checked.
        //For above refrence
        //if (_mgPayTo == (int)FixCodes.CommissionType.PAYTODRIVER)
        //{
        //    if (optTODrive100.Checked == true) {
        //        _driverComType = false;
        //    }
        //    else if (optTODriveSplit.Checked == true) {
        //        _driverComType = true;
        //    }
        //}
        //if (_mgPayTo == (int)FixCodes.CommissionType.PAYTODRIVER)
        //{
        //    optTODrive.Checked = true;
        //    _driverComType = fareResponse.DriverCommType;
        //    if (_driverComType == false) {
        //        optTODrive100.Checked = true;
        //    }
        //    else {
        //        optTODriveSplit.Checked = true;
        //    }
        //}

        newObject.gratuity = "";
        newObject.stop = parseFloat(this.state.extraStopCharge);
        newObject.noOfStop = parseInt(this.state.noOfStops);
        newObject.wtTotal = this.state.quoteId <= 0 ? 0.00 : parseInt(this.state.waitingChargeTotal);
        newObject.wtTime = parseInt(this.state.waitingTime);
        newObject.wt = parseFloat(this.state.waitingCharge);
        newObject.ot = parseFloat(this.state.otAmount);
        newObject.serviceFee = parseFloat(this.state.serviceFeeAmount);
        newObject.fuelSurCharge = parseFloat(this.state.fuelSurcharge);
        newObject.parking = parseFloat(this.state.parkingFee);
        newObject.portAuthority = parseFloat(this.state.portAuthority);
        newObject.utilityTax = parseFloat(this.state.utitity);
        newObject.wcTax = parseFloat(this.state.workCompantation);
        newObject.salesTax = parseFloat(this.state.salesTax);
        newObject.countyTax = parseFloat(this.state.countyTax);
        newObject.congestionTax = parseFloat(this.state.congestionTax);
        newObject.extraAmnt = parseFloat(this.state.extraAmount);
        newObject.extraAmntFor = this.state.extraAmountFor;
        newObject.gross = parseFloat(this.state.grossAmount);
        newObject.discount = parseFloat(this.state.discount);
        newObject.totalFare = parseFloat(this.state.totalFare);

        if (this.state.quoteId > 0) {

            if (this.state.paymentTypeId === 1 && this.state.paymentTermId === 2 && parseFloat(this.state.paidAmount) > 0) {
                if (parseFloat(this.state.totalFare) <= parseFloat(this.state.paidAmount)) {
                    newObject.billableFare = parseFloat(0);
                    newObject.totalPaid = parseFloat(this.state.paidAmount);
                } else {
                    newObject.billableFare = parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount);
                    newObject.totalPaid = parseFloat(this.state.paidAmount);
                }
            } else {
                if (this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')) {
                    if (parseFloat(this.state.totalFare) <= parseFloat(this.state.paidAmount)) {
                        newObject.billableFare = parseFloat(0);
                        newObject.totalPaid = parseFloat(this.state.paidAmount);
                    } else {
                        newObject.billableFare = parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount);
                        newObject.totalPaid = parseFloat(this.state.paidAmount);
                    }
                    newObject.partialPay = true;

                } else if ((this.state.paymentTypeId === 2 && !this.state.creditCard.includes('x')) || this.state.paymentTypeId === 3) {
                    newObject.billableFare = parseFloat(0);
                    newObject.totalPaid = parseFloat(this.state.paidAmount);
                } else {
                    newObject.billableFare = parseFloat(this.state.totalFare);
                    newObject.totalPaid = 0.00;
                }

            }
        } else {
            if (newObject.partialPay == false) {
                if (newObject.paymentTypeId == 2 || newObject.paymentTypeId == 3) {
                    newObject.billableFare = parseFloat(0);
                    newObject.totalPaid = parseFloat(this.state.paidAmount);
                } else {
                    newObject.billableFare = parseFloat(this.state.totalFare);
                    newObject.totalPaid = 0.00;
                }
            } else {
                if (newObject.paymentTypeId == 2 || newObject.paymentTypeId == 3) {
                    newObject.billableFare = parseFloat(this.state.totalFare) - parseFloat(this.state.paidAmount);
                    newObject.totalPaid = parseFloat(this.state.paidAmount);
                }
            }
        }


        newObject.chargeTo = "";
        newObject.agentName = this.state.agentCommissionName;
        newObject.agentCommission = parseFloat(this.state.agentCommissionAmount);

        newObject.rateLocked = this.state.isLockRates;
        newObject.currencyId = 0;
        newObject.exchangeRate = 0;
        newObject.totalTax = parseFloat(this.state.portAuthority) + parseFloat(this.state.utitity) + parseFloat(this.state.workCompantation) +
            parseFloat(this.state.salesTax) + parseFloat(this.state.countyTax) + parseFloat(this.state.congestionTax);
        newObject.GratuityAmount = 0;

        newObject.tripChangesLogs = this.state.quoteId <= 0 ? "" : this.getTripChangesDetails();


        newObject.TaxInclude = parseInt(this.state.taxOptionId);
        newObject.PaTaxApplicable = this.state.isAppliedPortAuthority;
        newObject.SalesTaxApplicable = this.state.isAppliedSalesTax;
        newObject.CountyTaxApplicable = this.state.isAppliedCountyTax;
        newObject.CongestionTaxApplicable = this.state.isAppliedCongestionTax;

        try {
            this.setState({ isSubmited: true });

            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('quotation-api/book', requestParams);
            const data = await response.json();

            let strAlert = "";

            if (!data.isSuccess) {
                if (data.retValue == -2000) {
                    strAlert = data.resultMessage;
                } else {
                    strAlert = "Quotation failed due to server error.";
                }
            } else {
                if (this.state.quoteId <= 0) {
                    strAlert = "Your quotation number is: <br><br>";
                } else {
                    strAlert = "Your quote has been modify and updated successfully.<br><br>";
                }
                strAlert += "\t" + data.quotationId + "<br>";
                strAlert += "<br> Thank you for booking.";


                //if (data.tripResult.length > 1) {
                //    if (this.state.tripTypeId == 3) {
                //        strAlert = "Your confirmation number is: <br><br>";
                //        strAlert += "\t" + data.reservationId + "<br>";
                //    }
                //    else {
                //        strAlert = "Your confirmation number is: " + data.reservationId + ".<br><br>";
                //        strAlert += "below are the trip(s). <br><br>";
                //        for (var i = 0; i < data.quoteResult.length; i++) {
                //            strAlert += "\t" + data.quoteResult[i].quoteId + "<br>";
                //        }
                //    }
                //    strAlert += "<br> Thank you for booking.";

                //} else {
                //    strAlert = "Your confirmation number is: <br><br>";

                //    strAlert += "\t" + data.reservationId + "<br>";

                //    strAlert += "<br> Thank you for booking.";
                //}
            }

            Swal.fire({
                icon: data.isSuccess ? 'success' : 'error',
                title: data.isSuccess ? 'Success' : 'Oops...',
                html: strAlert,
                width: "25%",
                allowOutsideClick: false
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (data.isSuccess) {
                    if (result.isConfirmed) {
                        this.setState({ isSubmited: false });
                        if (this.state.quoteId <= 0) {
                            if (this.state.isSendEmail == true) {
                                this.openEmailModal(this.state.puDateTime, data.quoteResult[0].quoteId, this.state.email, this.state.permanentRemark)
                            } else if (this.state.rateLookup != null) {
                                this.goToBack();
                            }
                            
                            this.clearAllControls();
                        } else {
                            this.goToBack();
                        }
                    }
                } else {
                    this.setState({ isSubmited: false });
                }
            })

        } catch (e) {
            this.setState({ isSubmited: false });
        }
    }

    goToBack() {
        this.props.history.push({
            pathname: this.state.sourceUrl,
            state: this.state.sourceState
        })
    }

    getTripChangesDetails() {
        let changes = ""
        let rideTypeIOldd = parseInt(this.state.tripDetails.rideTypeId);

        let puZone = null, doZone = null;
        if (rideTypeIOldd == 1) {
            puZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.puAreaId);
            doZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.doAreaId);
        } else if (rideTypeIOldd == 2) {
            puZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.puAreaId);
            doZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.doAreaId);
        } else if (rideTypeIOldd == 3) {
            puZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.puAreaId);
            doZone = this.state.dropdownZone.find(opt => opt.airportId == this.state.tripDetails.doAreaId);
        } else {
            puZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.puAreaId);
            doZone = this.state.dropdownZone.find(opt => opt.id == this.state.tripDetails.doAreaId);
        }

        if (this.state.paxFirstName != this.state.tripDetails.firstName) {
            changes += "Pax first name changed from " + this.state.tripDetails.firstName + " to " + this.state.paxFirstName + ". "
        }
        if (this.state.paxLastName != this.state.tripDetails.lastName) {
            changes += "Pax last name changed from " + this.state.tripDetails.lastName + " to " + this.state.paxLastName + ". "
        }
        if (this.state.countryCodePhone != this.state.tripDetails.countryCode) {
            changes += "Country code changed from " + this.state.tripDetails.countryCode + " to " + this.state.countryCodePhone + ". "
        }
        if (this.state.phoneNumber != this.state.tripDetails.phoneNo) {
            changes += "Phone no changed from " + this.state.tripDetails.phoneNo + " to " + this.state.phoneNumber + ". "
        }
        if (this.state.countryCode != this.state.tripDetails.cellCountryCode) {
            changes += "Cell country code changed from " + this.state.tripDetails.cellCountryCode + " to " + this.state.countryCode + ". "
        }
        if (this.state.mobileNumber != this.state.tripDetails.mobileNo) {
            changes += "Mobile number changed from " + this.state.tripDetails.mobileNo + " to " + this.state.mobileNumber + ". "
        }
        if (this.state.email != this.state.tripDetails.email) {
            changes += "Email changed from " + this.state.tripDetails.email + " to " + this.state.email + ". "
        }
        //if (this.state.poNumber != this.state.tripDetails.crewPo) {
        //    changes += "PO changed from " + this.state.tripDetails.crewPo + " to " + this.state.poNumber + ". "
        //}

        if (this.state.pickupLocation != this.state.tripDetails.puLocationName) {
            changes += "Pikcup location changed from " + this.state.tripDetails.puLocationName + " to " + this.state.pickupLocation + ". "
        }
        if (parseInt(this.state.pickupZoneId) != parseInt(puZone.id)) {
            let puZoneNew = this.state.dropdownZone.find(opt => opt.id == parseInt(this.state.pickupZoneId));
            changes += "Pikcup zone changed from " + puZone.name + " to " + puZoneNew.name + ". "
        }
        if (this.state.pickupAddress != this.state.tripDetails.puAddress) {
            changes += "Pikcup address changed from " + this.state.tripDetails.puAddress + " to " + this.state.pickupAddress + ". "
        }

        if (this.state.dropoffLocation != this.state.tripDetails.doLocationName) {
            changes += "Dropoff location changed from " + this.state.tripDetails.doLocationName + " to " + this.state.dropoffLocation + ". "
        }
        if (parseInt(this.state.dropoffZoneId) != parseInt(doZone.id)) {
            let doZoneNew = this.state.dropdownZone.find(opt => opt.id == parseInt(this.state.dropoffZoneId));
            changes += "Dropoff zone changed from " + doZone.name + " to " + doZoneNew.name + ". "
        }
        if (this.state.dropoffAddress != this.state.tripDetails.doAddress) {
            changes += "Pikcup address changed from " + this.state.tripDetails.doAddress + " to " + this.state.dropoffAddress + ". "
        }
        //if (parseInt(this.state.serviceSourceId) != parseInt(this.state.tripDetails.serviceSourceId)) {
        //    let newSource = parseInt(this.state.serviceSourceId) == 1 ? "In House" : (parseInt(this.state.serviceSourceId) == 2) ? "Farm In" : "Farm Out";
        //    let oldSource = parseInt(this.state.tripDetails.serviceSourceId) == 1 ? "In House" : (parseInt(this.state.tripDetails.serviceSourceId) == 2) ? "Farm In" : "Farm Out";

        //    changes += "Service source changed from " + oldSource + " to " + newSource + ". "
        //}

        //if (parseInt(this.state.otherAffiliateId) != parseInt(this.state.tripDetails.serviceSourceAffiliateId)) {
        //    if (parseInt(this.state.otherAffiliateId) > 0 && parseInt(this.state.tripDetails.serviceSourceAffiliateId) == 0) {
        //        let newSource = this.state.dropdownAffiliates.find(opt => opt.id == parseInt(this.state.otherAffiliateId));
        //        changes += "Source affiliate added " + newSource.name + ". "
        //    } else if (parseInt(this.state.otherAffiliateId) == 0 && parseInt(this.state.tripDetails.serviceSourceAffiliateId) > 0) {
        //        let oldSource = this.state.dropdownAffiliates.find(opt => opt.id == parseInt(this.state.tripDetails.serviceSourceAffiliateId));
        //        changes += "Source affiliate removed " + oldSource.name + ". "
        //    } else {
        //        let newSource = this.state.dropdownAffiliates.find(opt => opt.id == parseInt(this.state.otherAffiliateId));
        //        let oldSource = this.state.dropdownAffiliates.find(opt => opt.id == parseInt(this.state.tripDetails.serviceSourceAffiliateId));
        //        changes += "Source affiliate changed from " + oldSource.name + " to " + newSource.name + ". "
        //    }
        //}

        let airlineId = parseInt((rideTypeId == 1 || rideTypeId == 3) ? this.state.tripDetails.puAirlineId : this.state.tripDetails.doAirlineId);
        if (parseInt(this.state.airlineId) != airlineId) {
            if (parseInt(this.state.airlineId) > 0 && airlineId == 0) {
                let newAirline = this.state.dropdownAirline.find(opt => opt.airLineId == parseInt(this.state.airlineId));
                changes += "Airline added " + newAirline.airLineName + ". "
            } else if (parseInt(this.state.airlineId) == 0 && airlineId > 0) {
                let oldAirline = this.state.dropdownAirline.find(opt => opt.airLineId == airlineId);
                changes += "Airline removed " + oldAirline.airLineName + ". "
            } else {
                let newAirline = this.state.dropdownAirline.find(opt => opt.airLineId == parseInt(this.state.airlineId));
                let oldAirline = this.state.dropdownAirline.find(opt => opt.airLineId == airlineId);
                changes += "Airline changed from " + oldAirline.airLineName + " to " + newAirline.airLineName + ". "
            }
        }

        let flightNo = (rideTypeIOldd == 1 || rideTypeIOldd == 3) ? this.state.tripDetails.puAirlineNo : this.state.tripDetails.doAirlineNo;
        if (this.state.flightNumber != flightNo) {
            changes += "Flight number changed from " + flightNo + " to " + this.state.flightNumber + ". "
        }

        let terminal = (rideTypeIOldd == 1 || rideTypeIOldd == 3) ? this.state.tripDetails.puFlightTerminal : this.state.tripDetails.doFlightTerminal;
        if (this.state.terminal != terminal) {
            changes += "Terminal changed from " + terminal + " to " + this.state.terminal + ". "
        }

        let terminalType = parseInt((rideTypeIOldd == 1 || rideTypeIOldd == 3) ? this.state.tripDetails.puTerminalTypeId : this.state.tripDetails.doTerminalTypeId);
        if (parseInt(this.state.terminalType) != terminalType) {
            if (parseInt(this.state.terminalType) > 0 && terminalType == 0) {
                let newTerminal = terminalTypeData.find(opt => opt.id == parseInt(this.state.terminalType));
                changes += "Terminal type added " + newTerminal.name + ". "
            } else if (parseInt(this.state.terminalType) == 0 && terminalType > 0) {
                let oldTerminal = terminalTypeData.find(opt => opt.id == terminalType);
                changes += "Terminal type removed " + oldTerminal.name + ". "
            } else {
                let newTerminal = terminalTypeData.find(opt => opt.id == parseInt(this.state.terminalType));
                let oldTerminal = terminalTypeData.find(opt => opt.id == terminalType);
                changes += "Terminal type changed from " + oldTerminal.name + " to " + newTerminal.name + ". "
            }
        }
        let flightDate = (rideTypeIOldd == 1 || rideTypeIOldd == 3) ? new Date(this.state.tripDetails.puFlightDateTime) : new Date(this.state.tripDetails.doFlightDateTime)
        if ((this.state.puDateTime.toLocaleDateString() + " " + this.state.flightTime.toLocaleTimeString()) != (flightDate.toLocaleDateString() + " " + flightDate.toLocaleTimeString())) {
            changes += "Flight date changed from " + flightDate.toLocaleDateString() + " " + flightDate.toLocaleTimeString() + " to " + this.state.puDateTime.toLocaleDateString() + " " + this.state.flightTime.toLocaleTimeString() + ". "
        }

        if (this.state.orderByName != this.state.tripDetails.orderBy) {
            changes += "Order by changed from " + this.state.tripDetails.orderBy + " to " + this.state.orderByName + ". "
        }
        //if (this.state.countryCodeOrderPhone != this.state.tripDetails.orderByCountryCode) {
        //    changes += "Order by country code changed from " + this.state.tripDetails.orderByCountryCode + " to " + this.state.countryCodeOrderPhone + ". "
        //}
        if (this.state.phoneNumberOrder != this.state.tripDetails.orderPhone) {
            changes += "Order by phone no changed from " + this.state.tripDetails.orderPhone + " to " + this.state.phoneNumberOrder + ". "
        }
        //if (this.state.emailOrder != this.state.tripDetails.orderByEmail) {
        //    changes += "Order by email changed from " + this.state.tripDetails.orderByEmail + " to " + this.state.emailOrder + ". "
        //}

        if (parseInt(this.state.reservationModeId) != parseInt(this.state.tripDetails.reservationModeId)) {
            let newMode = this.state.dropdownReservationMode.find(opt => opt.id == parseInt(this.state.reservationModeId));
            let oldMode = this.state.dropdownReservationMode.find(opt => opt.id == parseInt(this.state.tripDetails.reservationModeId));
            changes += "Source affiliate changed from " + oldMode.name + " to " + newMode.name + ". "
        }

        if ((this.state.puDateTime.toLocaleDateString() + " " + this.state.puDateTime.toLocaleTimeString()) != (new Date(this.state.tripDetails.puDateTime).toLocaleDateString() + " " + new Date(this.state.tripDetails.puDateTime).toLocaleTimeString())) {
            changes += "Pickup date changed from " + new Date(this.state.tripDetails.puDateTime).toLocaleDateString() + " " + new Date(this.state.tripDetails.puDateTime).toLocaleTimeString() + " to " + this.state.puDateTime.toLocaleDateString() + " " + this.state.puDateTime.toLocaleTimeString() + ". "
        }
        if (parseInt(this.state.vehicleTypeId) != parseInt(this.state.tripDetails.apiVehicleTypeId)) {
            let newVehicleType = this.state.dropdownVehicleType.find(opt => opt.rowIndex == parseInt(this.state.vehicleTypeId));
            let oldVehicleType = this.state.dropdownVehicleType.find(opt => opt.rowIndex == parseInt(this.state.tripDetails.apiVehicleTypeId));
            changes += "Vehicle type changed from " + oldVehicleType.apiVehicleTypeDescription + " to " + newVehicleType.apiVehicleTypeDescription + ". "
        }
        if (parseInt(this.state.noOfPax) != parseInt(this.state.tripDetails.adultNo)) {
            changes += "Pax count changed from " + this.state.tripDetails.adultNo + " to " + this.state.noOfPax + ". "
        }
        if (parseInt(this.state.luggage) != parseInt(this.state.tripDetails.baggageCount)) {
            changes += "Luggage count changed from " + this.state.tripDetails.baggageCount + " to " + this.state.luggage + ". "
        }

        if (this.state.isAccessible != this.state.tripDetails.isAccessible) {
            if (this.state.isAccessible == true) {
                changes += "Accessible changed from NO to YES. ";
            } else {
                changes += "Accessible changed from YES to NO. ";
            }
        }
        //if (this.state.isVipTrip != (this.state.tripDetails.vip === 'Y' ? true : false)) {
        //    if (this.state.isVipTrip == true) {
        //        changes += "VIP changed from NO to YES. ";
        //    } else {
        //        changes += "VIP changed from YES to NO. ";
        //    }
        //}
        //if (this.state.isPriorityTrip != (this.state.tripDetails.priority === 'Y' ? true : false)) {
        //    if (this.state.isPriorityTrip == true) {
        //        changes += "Priority changed from NO to YES. ";
        //    } else {
        //        changes += "Priority changed from YES to NO. ";
        //    }
        //}
        if (this.state.isMeetGreet != this.state.tripDetails.isMgRequired) {
            if (this.state.isMeetGreet == true) {
                changes += "MeetGreet changed from NO to YES. ";
            } else {
                changes += "MeetGreet changed from YES to NO. ";
            }
        }
        if (this.state.isLockRates != this.state.tripDetails.rateLocked) {
            if (this.state.isLockRates == true) {
                changes += "Lock rate changed from NO to YES. ";
            } else {
                changes += "Lock rate changed from YES to NO. ";
            }
        }
        if (this.state.specialInstruction != this.state.tripDetails.specialInstruction) {
            changes += "Spcl Inst. changed from " + this.state.tripDetails.specialInstruction + " to " + this.state.specialInstruction + ". "
        }
        if (this.state.permanentRemark != this.state.tripDetails.permanentRemark) {
            changes += "Permanent remark. changed from " + this.state.tripDetails.permanentRemark + " to " + this.state.permanentRemark + ". "
        }
        //if (this.state.pickupNotes != this.state.tripDetails.pickUpNotes) {
        //    changes += "Pickup notes changed from " + this.state.tripDetails.pickUpNotes + " to " + this.state.pickupNotes + ". "
        //}
        //if (this.state.billToNotes != this.state.tripDetails.billToNotes) {
        //    changes += "Bill notes. changed from " + this.state.tripDetails.billToNotes + " to " + this.state.billToNotes + ". "
        //}

        if (parseInt(this.state.paymentTypeId) != parseInt(this.state.tripDetails.paymentTypeId)) {
            let newMode = this.state.dropdownPaymentType.find(opt => opt.id == parseInt(this.state.paymentTypeId));
            let oldMode = this.state.dropdownPaymentType.find(opt => opt.id == parseInt(this.state.tripDetails.paymentTypeId));
            changes += "Payment type changed from " + oldMode.name + " to " + newMode.name + ". "
        }

        if (parseInt(this.state.paymentTermId) != parseInt(this.state.tripDetails.partialPay == false ? 1 : 2)) {
            if (this.state.paymentTermId == 2) {
                changes += "Partial payment applied. ";
            } else {
                changes += "Paid in full. ";
            }
        }

        if (parseFloat(this.state.rideAmount) != parseFloat(this.state.tripDetails.rideAmount)) {
            changes += "Ride amount changed from " + this.state.tripDetails.rideAmount + " to " + this.state.rideAmount + ". "
        }
        if (parseFloat(this.state.tollAmount) != parseFloat(this.state.tripDetails.tollAmount)) {
            changes += "Toll amount changed from " + this.state.tripDetails.tollAmount + " to " + this.state.tollAmount + ". "
        }
        if (parseFloat(this.state.tipAmount) != parseFloat(this.state.tripDetails.tipAmount)) {
            changes += "Tip amount changed from " + this.state.tripDetails.tipAmount + " to " + this.state.tipAmount + ". "
        }
        if (parseFloat(this.state.otAmount) != parseFloat(this.state.tripDetails.ot)) {
            changes += "Ot amount changed from " + this.state.tripDetails.ot + " to " + this.state.otAmount + ". "
        }
        if (parseFloat(this.state.serviceFeeAmount) != parseFloat(this.state.tripDetails.serviceFee)) {
            changes += "Service fee amount changed from " + this.state.tripDetails.serviceFee + " to " + this.state.serviceFeeAmount + ". "
        }
        if (parseFloat(this.state.fuelSurcharge) != parseFloat(this.state.tripDetails.fuelSurCharge)) {
            changes += "Fuel sur charge amount changed from " + this.state.tripDetails.fuelSurcharge + " to " + this.state.fuelSurCharge + ". "
        }
        if (parseFloat(this.state.parkingFee) != parseFloat(this.state.tripDetails.parking)) {
            changes += "Parking amount changed from " + this.state.tripDetails.parking + " to " + this.state.parkingFee + ". "
        }
        if (parseFloat(this.state.tourGuideCharge) != parseFloat(this.state.tripDetails.tourGuideCharge)) {
            changes += "Tour guide amount changed from " + this.state.tripDetails.tourGuideCharge + " to " + this.state.tourGuideCharge + ". "
        }
        if (parseFloat(this.state.payToTourGuide) != parseFloat(this.state.tripDetails.payToTourGuide)) {
            changes += "Pay to tour guide amount changed from " + this.state.tripDetails.payToTourGuide + " to " + this.state.payToTourGuide + ". "
        }
        if (parseFloat(this.state.extraAmount) != parseFloat(this.state.tripDetails.extraAmount)) {
            changes += "Extra amount changed from " + this.state.tripDetails.extraAmount + " to " + this.state.extraAmount + ". "
        }
        if (parseFloat(this.state.waitingCharge) != parseFloat(this.state.tripDetails.waitCharge)) {
            changes += "Waiting charged changed from " + this.state.tripDetails.waitCharge + " to " + this.state.waitingCharge + ". "
        }
        if (parseInt(this.state.waitingTime) != parseInt(this.state.tripDetails.waitTime)) {
            changes += "Waiting time changed from " + this.state.tripDetails.waitTime + " to " + this.state.waitingTime + ". "
        }
        if (parseFloat(this.state.extraStopCharge) != parseFloat(this.state.tripDetails.stopCharge)) {
            changes += "Stop charged changed from " + this.state.tripDetails.stopCharge + " to " + this.state.extraStopCharge + ". "
        }
        if (parseInt(this.state.noOfStops) != parseInt(this.state.tripDetails.noOfStop)) {
            changes += "No of stop changed from " + this.state.tripDetails.noOfStop + " to " + this.state.noOfStops + ". "
        }
        if (parseFloat(this.state.meetGreet) != parseFloat(this.state.tripDetails.meetGreetCharge)) {
            changes += "Meetgreet charge changed from " + this.state.tripDetails.meetGreetCharge + " to " + this.state.meetGreet + ". "
        }
        if (this.state.mgToPay != this.state.tripDetails.mgPayTo) {
            //1 => Pay To Greeter, 2 => 100 % to Company, 3 => Pay to Driver;
            let newPay = parseInt(this.state.mgToPay) == 1 ? "Pay To Greeter" : (parseInt(this.state.mgToPay) == 2) ? "100 % to Company" : "Pay to Driver";
            let oldPay = parseInt(this.state.tripDetails.mgPayTo) == 1 ? "Pay To Greeter" : (parseInt(this.state.tripDetails.mgPayTo) == 2) ? "100 % to Company" : "Pay to Driver";
            changes += "Meetgreet payment type changed from " + oldPay + " to " + newPay + ". "
        }

        if (parseFloat(this.state.payMeetGreetAmount) != parseFloat(this.state.tripDetails.meetGreetAmount)) {
            changes += "Meetgreet amount changed from " + this.state.tripDetails.meetGreetAmount + " to " + this.state.payMeetGreetAmount + ". "
        }
        if (this.state.mgDriverComms != (this.state.tripDetails.mgDriverComms == false ? "1" : "2")) {
            let newPay = parseInt(this.state.mgDriverComms) == 1 ? "PayToDriver 100%" : "PayToDriver Split";
            let oldPay = this.state.tripDetails.mgDriverComms == false ? "PayToDriver 100%" : "PayToDriver Split";

            changes += "Driver comm type changed from " + oldPay + " to " + newPay + ". "
        }

        if (this.state.agentCommissionName != this.state.tripDetails.agentName) {
            changes += "Agent changed from " + this.state.tripDetails.agentName + " to " + this.state.agentCommissionName + ". "
        }
        if (parseFloat(this.state.agentCommissionAmount) != parseFloat(this.state.tripDetails.agentCommission)) {
            changes += "Agent commission changed from " + this.state.tripDetails.agentCommission + " to " + this.state.agentCommissionAmount + ". "
        }
        if (parseFloat(this.state.discount) != parseFloat(this.state.tripDetails.discount)) {
            changes += "Discount changed from " + this.state.tripDetails.discount + " to " + this.state.discount + ". "
        }
        if (parseFloat(this.state.totalFare) != parseFloat(this.state.tripDetails.totalFare)) {
            changes += "Total fare changed from " + this.state.tripDetails.totalFare + " to " + this.state.totalFare + ". "
        }

        if (parseInt(this.state.taxOptionId) != parseInt(this.state.tripDetails.taxInclude)) {
            //1 => Exempted, 2 => Includedd In fare, 3 => Add To Fare
            let newPay = parseInt(this.state.taxOptionId) == 1 ? "Exempted" : (parseInt(this.state.taxOptionId) == 2) ? "Includedd In fare" : "Add To Fare";
            let oldPay = parseInt(this.state.tripDetails.taxInclude) == 1 ? "Exempted" : (parseInt(this.state.tripDetails.taxInclude) == 2) ? "Includedd In fare" : "Add To Fare";
            changes += "Meetgreet payment type changed from " + oldPay + " to " + newPay + ". "
        }

        if (this.state.isAppliedPortAuthority != this.state.tripDetails.paApplicable) {
            if (this.state.isAppliedPortAuthority == true) {
                changes += "Port Authority changed from NO to YES. ";
            } else {
                changes += "Port Authority changed from YES to NO. ";
            }
        }

        if (this.state.isAppliedSalesTax != this.state.tripDetails.salesTaxApplicable) {
            if (this.state.isAppliedSalesTax == true) {
                changes += "Sales tax changed from NO to YES. ";
            } else {
                changes += "Sales tax changed from YES to NO. ";
            }
        }

        if (this.state.isAppliedCountyTax != this.state.tripDetails.countyTaxApplicable) {
            if (this.state.isAppliedCountyTax == true) {
                changes += "County tax changed from NO to YES. ";
            } else {
                changes += "County tax changed from YES to NO. ";
            }
        }

        if (this.state.isAppliedCongestionTax != this.state.tripDetails.congestionTaxApplicable) {
            if (this.state.isAppliedCongestionTax == true) {
                changes += "Congestion tax changed from NO to YES. ";
            } else {
                changes += "Congestion tax changed from YES to NO. ";
            }
        }

        if (changes === "") {
            changes = "Ride updated without any changes."
        }

        return changes;
    }

    clearAllControls() {
        rideTypeId = 0;
        this.setState({
            quoteId: 0,
            paxFirstName: '',
            paxLastName: '',
            countryCodePhone: '1',
            phoneNumber: '',
            countryCode: '1',
            mobileNumber: '',
            email: '',
            isSendEmail: false,
            poNumber: '',

            isPickupGoogleBooking: false,
            pickupLocation: "",
            pickupZoneId: 0,
            pickupAddress: "",
            pickupAddressType: "",
            pickupCity: "",
            pickupState: "",
            pickupZipCode: "",
            pickupLatitude: 0,
            pickupLongitude: 0,
            isDropoffGoogleBooking: false,
            dropoffLocation: "",
            dropoffZoneId: 0,
            dropoffAddress: "",
            dropoffAddressType: "",
            dropoffCity: "",
            dropoffState: "",
            dropoffZipCode: "",
            dropoffLatitude: 0,
            dropoffLongitude: 0,
            serviceSourceId: 1,
            otherAffiliateId: 0,

            airlineId: 0,
            flightNumber: '',
            terminalType: 1,
            terminal: '',
            flightTime: currentTime,

            airlineIdReturn: 0,
            flightNumberReturn: '',
            terminalTypeReturn: 1,
            terminalReturn: '',
            flightTimeReturn: currentTime,

            orderByName: '',
            countryCodeOrderPhone: '',
            phoneNumberOrder: '',
            emailOrder: '',
            reservationModeId: 0,
            puDateTime: currentTime,
            puDateTimeReturn: currentTime,

            doDateTime: currentTime,
            tripDuration: 0,
            vehicleTypeId: 0,
            noOfPax: 1,
            noOfPaxReturn: 1,
            luggage: 0,
            noOfTrip: 1,
            isAccessible: false,
            isVipTrip: false,
            isPriorityTrip: false,
            isMeetGreet: false,
            tripTypeId: "1",
            isLockRates: false,
            recurringTypeId: 2,
            recurringEndDate: "",
            selectedDays: [],
            isWeekSun: false,
            isWeekMon: false,
            isWeekTue: false,
            isWeekWed: false,
            isWeekThu: false,
            isWeekFri: false,
            isWeekSat: false,
            isMonthSun: false,
            isMonthMon: false,
            isMonthTue: false,
            isMonthWed: false,
            isMonthThu: false,
            isMonthFri: false,
            isMonthSat: false,
            specialInstruction: "",
            permanentRemark: "",
            pickupNotes: "",
            billToNotes: "",
            customerRateTax: null,


            paymentTypeId: 1,
            voucherCompanyId: 0,
            paymentTermId: 1,
            existingCardId: 0,
            cardExpiry: "",
            cardType: "",
            cardImage: 'data:image/svg+xml;base64,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',
            creditCard: "",
            checkNumber: "",
            checkDate: "",
            checkBank: "",
            chargeTo: "",
            voucherCode: "",

            rideAmount: 0.000,
            tollAmount: 0.000,
            tipAmount: 0.000,
            otAmount: 0.000,
            serviceFeeAmount: 0.000,
            fuelSurcharge: 0.000,
            parkingFee: 0.000,
            tourGuideCharge: 0.000,
            payToTourGuide: 0.000,
            extraAmount: 0.000,
            extraAmountFor: "",
            waitingCharge: 0.000,
            waitingTime: 0,
            waitingChargeTotal: 0.000,
            extraStopCharge: 0.000,
            noOfStops: 0,
            stopTotal: 0.000,
            meetGreet: 0.000,
            mgToPay: "2",
            payMeetGreetId: 0,
            payMeetGreetAmount: 0.000,
            mgDriverComms: "1",
            agentCommissionId: 0,
            agentCommissionName: "",
            agentCommissionAmount: 0.000,
            discount: 0.000,

            portAuthority: 0.000,
            utitity: 0.000,
            countyTax: 0.000,
            congestionTax: 0.000,
            workCompantation: 0.000,
            salesTax: 0.000,
            grossAmount: 0.000,
            totalFare: 0.000,
            paidAmount: 0.000,

            taxOptionId: "3",
            isAppliedPortAuthority: true,
            isAppliedSalesTax: true,
            isAppliedCountyTax: true,
            isAppliedCongestionTax: true,

            loadPanelVisible: false,

            errors: {
                paxFirstName: "",
                paxLastName: "",
                countryCode: "",
                mobileNumber: "",
                email: "",
                pickupLocation: "",
                pickupZoneId: "",
                dropoffLocation: "",
                dropoffZoneId: "",
                otherAffiliateId: "",
                puDateTime: "",
                doDateTime: "",
                flightTime: "",
                flightNumber: "",
                terminalType: "",
                flightNumberReturn: "",
                terminalTypeReturn: "",
                flightTimeReturn: "",
                orderByName: "",
                reservationModeId: "",
                vehicleTypeId: "",
                noOfTrip: "",
                noOfPax: "",
                noOfPaxReturn: "",
                recurringEndDate: "",
                recurring: "",

                rideAmount: "",
                payMeetGreetId: "",
                payMeetGreetAmount: "",

                paymentTypeId: "",
                paidAmount: "",
                checkNumber: "",
                checkDate: "",
                checkBank: "",
                existingCardId: "",
                creditCard: "",
                cardType: "",
                cardExpiry: "",
                voucherCompanyId: "",
                voucherCode: "",
            }
        });
    }

    getRideTypeId(fromZId, toZId) {
        rideTypeId = 0;
        this.setState({ isMeetGreet: false });

        if (fromZId > 0 && toZId > 0) {
            let puZone = this.state.dropdownZone.find(opt => opt.id == fromZId);
            let doZone = this.state.dropdownZone.find(opt => opt.id == toZId);

            if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
                this.setState({ isMeetGreet: false });
                rideTypeId = 1;
            } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
                this.setState({ isMeetGreet: false });
                rideTypeId = 2;
            } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
                this.setState({ isMeetGreet: false });
                rideTypeId = 3;
            } else {
                this.setState({ isMeetGreet: false });
                rideTypeId = 13;
            }
        }
    }

    async getCustomerRateTaxSetting(fromZId, toZId, puDateTime, vTypeId, pCount, hNumber, bMeetGreet) {
        try {

            if (fromZId > 0 && toZId > 0 && puDateTime != '' && vTypeId > 0 && pCount > 0) {

                let fromAirId = 0, toAirId = 0, fromZoneId = 0, toZoneId = 0;

                let puZone = this.state.dropdownZone.find(opt => opt.id == fromZId);
                let doZone = this.state.dropdownZone.find(opt => opt.id == toZId);

                if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 3) {
                    fromAirId = puZone.airportId;
                    toZoneId = doZone.id;
                } else if (puZone.zoneTypeId === 3 && doZone.zoneTypeId === 1) {
                    fromZoneId = puZone.id;
                    toAirId = doZone.airportId;
                } else if (puZone.zoneTypeId === 1 && doZone.zoneTypeId === 1) {
                    fromAirId = puZone.airportId;
                    toAirId = doZone.airportId;
                } else {
                    fromZoneId = puZone.id;
                    toZoneId = doZone.id;
                }

                var newObject = new Object();
                newObject.RideTypeId = rideTypeId;
                newObject.FromAirportId = fromAirId;
                newObject.ToAirportId = toAirId;
                newObject.FromZoneId = fromZoneId;
                newObject.ToZoneId = toZoneId;
                newObject.PickUpDateTime = puDateTime.toLocaleDateString() + " " + puDateTime.toLocaleTimeString();
                newObject.ApiVehicleTypeId = vTypeId;
                newObject.NoOfHours = hNumber;
                newObject.NoOfPax = pCount;
                newObject.RateId = this.state.rateId;
                newObject.IsMgRequired = bMeetGreet;

                const requestParams = getRequestParams('POST', newObject);
                const response = await fetch('customer-api/0/rate-tax-setting', requestParams);
                const data = await response.json();

                this.setState({
                    customerRateTax: data
                });

                this.fillRateControls(data);
            }
        } catch (e) {
            console.log(e);
        }
    }

    fillRateControls(rates) {
        if (this.state.quoteId > 0) {
            if (this.state.isLockRates == false) {
                this.setState({
                    meetGreet: parseFloat(rates.meetGreetCharge),
                    rideAmount: parseFloat(rates.rate),
                    tollAmount: parseFloat(rates.tollAmount),
                    tipAmount: parseFloat(rates.tipAmount),
                    parkingFee: parseFloat(rates.parking),
                    fuelSurcharge: parseFloat(rates.fuelSurCharge),
                    tourGuideCharge: 0.000,
                    payToTourGuide: 0.000,
                    waitingCharge: parseFloat(rates.waitCharge),
                    extraStopCharge: parseFloat(rates.stop),
                    otAmount: 0.000,
                    serviceFeeAmount: parseFloat(rates.serviceFee),
                    agentCommissionAmount: parseFloat(rates.agentCommission),
                    grossAmount: parseFloat(rates.fare),
                    discount: parseFloat(rates.discountCharge),
                    totalFare: parseFloat(rates.totalFare),
                    paidAmount: 0.00,
                });
            } else {
                if (parseInt(this.state.tripDetails.invoiceNo) <= 0) {
                    this.setState({
                        portAuthority: parseFloat(rates.portAuthority),
                        utitity: parseFloat(rates.utilityTax),
                        workCompantation: parseFloat(rates.wcTax),
                        salesTax: parseFloat(rates.salesTax),
                        countyTax: parseFloat(rates.countyTax),
                        congestionTax: parseFloat(rates.congestionTax),
                    });

                    let myVar = setTimeout(() => this.calculateFare("", 0), 500)
                }
            }
        } else {
            this.setState({
                rideAmount: parseFloat(rates.rate),
                tollAmount: parseFloat(rates.tollAmount),
                tipAmount: parseFloat(rates.tipAmount),
                otAmount: 0.000,
                serviceFeeAmount: parseFloat(rates.serviceFee),
                fuelSurcharge: parseFloat(rates.fuelSurCharge),
                parkingFee: parseFloat(rates.parking),
                tourGuideCharge: 0.000,
                payToTourGuide: 0.000,
                extraAmount: 0.000,
                extraAmountFor: "",
                waitingCharge: parseFloat(rates.waitCharge),
                waitingTime: 0,
                waitingChargeTotal: 0.000,
                extraStopCharge: parseFloat(rates.stop),
                noOfStops: 0,
                stopTotal: 0.000,
                meetGreet: parseFloat(rates.meetGreetCharge),
                mgToPay: "2",
                payMeetGreetId: 0,
                payMeetGreetAmount: 0.000,
                mgDriverComms: "1",
                agentCommissionId: rates.agentId,
                agentCommissionName: rates.agentName,
                agentCommissionAmount: parseFloat(rates.agentCommission),
                discount: 0.000,

                portAuthority: parseFloat(rates.portAuthority),
                utitity: parseFloat(rates.utilityTax),
                workCompantation: parseFloat(rates.wcTax),
                salesTax: parseFloat(rates.salesTax),
                countyTax: parseFloat(rates.countyTax),
                congestionTax: parseFloat(rates.congestionTax),

                taxOptionId: rates.taxInclude.toString(),
                isAppliedPortAuthority: rates.allowPortAuthTax,
                isAppliedSalesTax: rates.allowSalesTax,
                isAppliedCountyTax: rates.allowCountyTax,
                isAppliedCongestionTax: rates.allowCongestionTax,


                grossAmount: parseFloat(rates.fare),
                totalFare: parseFloat(rates.totalFare),
                paidAmount: 0.00,
            });


        }

    }

    async askCancelQuoteConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "You are going to cancel this Quote!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            cancelButtonText: 'Close',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async handleCancelSubmit() {
        const isConfirm = await this.askCancelQuoteConfirm();
        if (!isConfirm) {
            return;
        } else {
            try {

                var newObject = new Object();
                newObject.QuatationId = this.state.tripDetails.quotationId;
                newObject.QuoteId = this.state.tripDetails.quoteId;
                newObject.StatusId = 317;
                newObject.historyLog = "Quote cancelled.";
                this.setState({ isCancelSubmited: true });
                const requestParams = getRequestParams('POST', newObject);
                const response = await fetch('quotation-api/update-status', requestParams);
                const data = await response.json();


                Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? 'Success' : 'Oops...',
                    text: data.resultMessage,
                    width: "30%",
                    allowOutsideClick: false
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (data.isSuccess) {
                        if (result.isConfirmed) {
                            this.setState({ isCancelSubmited: false });
                            this.goToBack();
                        }
                    } else {
                        this.setState({ isCancelSubmited: false });
                    }
                })


            } catch (e) {
                console.log(e);
            }
        }
    }

    async askEmailQuoteConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Are you sure</small>",
            html: "You are going to email this Quote!<br> Do you want to still continue?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            cancelButtonText: 'Close',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async askShowFareConfirm() {
        let isResult = false;
        await Swal.fire({
            title: "<small>Fare Confirmation</small>",
            html: "Do you want to print/ show fare details in quotation?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            allowOutsideClick: false
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        })
        return isResult;
    }

    async handleDownload(e) {
        e.preventDefault();
        var isShowFare = false;
        const isConfirm = await this.askShowFareConfirm();
        if (!isConfirm) {
            isShowFare = false;
        } else {
            isShowFare = true;
        }

        this.setState({
            //loadPanelVisible: true,
            loadPanelVisible: true,
        });


        var request = new Object();
        request.QuoteId = parseInt(this.state.quoteId);
        request.IsShowRate = isShowFare;
        request.PermanantRemark = this.state.tripDetails.permanentRemark;
        request.fileFormat = 'pdf';
        request.MethodName = "GetQuoteReport";
        const requestParams = getRequestParams('POST', request);
        const response = await fetch('crystal-report-api', requestParams);
        const dataResponse = await response.json();
        this.setState({
            // loadPanelVisible: false,
            loadPanelVisible: false,
        });
        let a = document.createElement('a');
        a.href = dataResponse.reportBase64String;
        a.download = "Quotation" + this.state.quoteId + ".pdf";
        a.click();
    }

    async handleEmailSubmit(e) {
        e.preventDefault();
        this.openEmailModal(this.state.tripDetails.puDateTime, this.state.quoteId, this.state.tripDetails.email, this.state.tripDetails.permanentRemark)
    }

    async openEmailModal(puDateTime, quoteId, emailId,permanantRemark) {

        let attachments = [];
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));

        var strSubject = sessionStorage.getItem("session_accountname") + " Quotation: " + new Date(puDateTime).toDateString() + " " + new Date(puDateTime).toTimeString() + " (Quote Id: " + quoteId + ") ";

        let strFileName = "Quotation" + quoteId;

        var isShowFare = false;
        const isConfirm = await this.askShowFareConfirm();
        if (!isConfirm) {
            isShowFare = false;
        } else {
            isShowFare = true;
        }

        this.setState({
            loadPanelVisible: true,
        });


        var request = new Object();
        request.QuoteId = parseInt(quoteId);
        request.IsShowRate = isShowFare;
        request.PermanantRemark = permanantRemark;
        request.fileFormat = 'pdf';
        request.MethodName = "GetQuoteReport";
        const requestParams = getRequestParams('POST', request);
        const response = await fetch('crystal-report-api', requestParams);
        const dataResponse = await response.json();
        let fileData = dataResponse.reportBase64String;
        if (fileData !== null && fileData !== '') {

            //let emailSubject = 'Data Entry Audit Report - ' + moment(currentTime).format("DD MMMM YYYY HH:mm");
            let file = new Object();
            file.fileData = fileData;
            file.fileName = strFileName + '.pdf';
            file.fileExtension = '.pdf';
            attachments.push(file);
            this.setState({
                loadPanelVisible: false,
            });
            this.refs.voucherEmailComponent.showModal(0, quoteId, emailId, '', strSubject, '', attachments);
        }
        else {
            this.setState({
                loadPanelVisible: false,
            });

            Swal.fire({
                allowOutsideClick: false,
                showCloseButton: true,
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong! Unable to process the email request.',
            })
        }




        //try {

        //    var newObject = new Object();
        //    newObject.QuatationId = this.state.tripDetails.quotationId;
        //    newObject.QuoteId = this.state.tripDetails.quoteId;
        //    newObject.StatusId = 316;
        //    newObject.historyLog = "Quote emailed.";
        //    this.setState({ isEmailSubmited: true });
        //    const requestParams = getRequestParams('POST', newObject);
        //    const response = await fetch('quotation-api/update-status', requestParams);
        //    const data = await response.json();


        //    Swal.fire({
        //        icon: data.isSuccess ? 'success' : 'error',
        //        title: data.isSuccess ? 'Success' : 'Oops...',
        //        text: data.resultMessage,
        //        width: "30%",
        //        allowOutsideClick: false
        //    }).then((result) => {
        //        /* Read more about isConfirmed, isDenied below */
        //        if (data.isSuccess) {
        //            if (result.isConfirmed) {
        //                this.setState({ isEmailSubmited: false });
        //                this.goToBack();
        //            }
        //        } else {
        //            this.setState({ isEmailSubmited: false });
        //        }
        //    })


        //} catch (e) {
        //    console.log(e);
        //}
        //}
    }


    handleConfirmSubmit(e) {
        e.preventDefault();
        this.refs.confirmQuoteModal.showModal("Quotation", this.state.quoteId);
    }

    getRecurringPuDateArrayList() {
        var puDateArrayList = [];

        if (this.state.recurringTypeId == 1) {
            puDateArrayList = this.getDailyRecurringDays();
        } else if (this.state.recurringTypeId == 2) {
            puDateArrayList = this.getWeeklyRecurringDays();
        } else if (this.state.recurringTypeId == 3) {
            puDateArrayList = this.getMonthlyRecurringDays();
        }

        return puDateArrayList;
    }

    diffDays(d1, d2) {
        var ndays;
        var tv1 = d1.valueOf();  // msec since 1970
        var tv2 = d2.valueOf();

        ndays = (tv2 - tv1) / 1000 / 86400;
        ndays = Math.round(ndays - 0.5);
        return ndays;
    }

    getDailyRecurringDays() {
        var finalArrayList = [];

        var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        var enDate = new Date(new Date(this.state.recurringEndDate).toLocaleDateString());
        var dayscount = this.diffDays(stpuDate, enDate) + 1;

        var chkPuDay = [];
        chkPuDay = this.getDaysOfDailyRec();
        for (var day = 1; day <= dayscount; day++) {
            for (var scount = 0; scount < chkPuDay.length; scount++) {
                if ((stpuDate.toLocaleDateString()) === chkPuDay[scount]) {
                    finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
                }
            }
            stpuDate.setDate(stpuDate.getDate() + 1);
        }

        return finalArrayList;
    }

    getWeeklyRecurringDays() {
        var finalArrayList = [];

        var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        var enDate = new Date(new Date(this.state.recurringEndDate).toLocaleDateString());

        var dayscount = this.diffDays(stpuDate, enDate) + 1;

        var chkPuDay = [];
        chkPuDay = this.getDaysOfWeeklyRec();
        for (var day = 1; day <= dayscount; day++) {
            for (var scount = 0; scount < chkPuDay.length; scount++) {
                if (stpuDate.getDay() == chkPuDay[scount].toString()) {
                    finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
                }
            }
            stpuDate.setDate(stpuDate.getDate() + 1);
        }
        return finalArrayList;
    }

    getMonthlyRecurringDays() {
        var finalArrayList = [];

        var stpuDate = new Date(new Date(this.state.puDateTime).toLocaleDateString());
        var enDate = new Date(new Date(this.state.recurringEndDate).toLocaleDateString());

        var dayscount = this.diffDays(stpuDate, enDate) + 1;
        var chkPuDay = [];
        chkPuDay = this.getDaysOfMonthlyRec();
        for (var day = 1; day <= dayscount; day++) {
            for (var scount = 0; scount < chkPuDay.length; scount++) {
                if (stpuDate.getDay() == chkPuDay[scount].toString()) {
                    finalArrayList.push(((stpuDate.getMonth() + 1) < 10 ? "0" + (stpuDate.getMonth() + 1) : (stpuDate.getMonth() + 1)) + '/' + (stpuDate.getDate() < 10 ? "0" + stpuDate.getDate() : stpuDate.getDate()) + '/' + stpuDate.getFullYear());
                }
            }
            stpuDate.setDate(stpuDate.getDate() + 1);
        }
        return finalArrayList;
    }

    getDaysOfDailyRec() {
        var chkPuDate = [];

        var allDays = [];
        allDays = this.state.selectedDays;
        for (var i = 0; i < allDays.length; i++) {
            chkPuDate.push(allDays[i].toLocaleDateString());
        }

        return chkPuDate;
    }

    getDaysOfWeeklyRec() {
        var chkPuDays = [];
        if (this.state.isWeekMon === true) {
            chkPuDays.push(1);
        }
        if (this.state.isWeekTue === true) {
            chkPuDays.push(2);
        }
        if (this.state.isWeekWed === true) {
            chkPuDays.push(3);
        }
        if (this.state.isWeekThu === true) {
            chkPuDays.push(4);
        }
        if (this.state.isWeekFri === true) {
            chkPuDays.push(5);
        }
        if (this.state.isWeekSat === true) {
            chkPuDays.push(6);
        }
        if (this.state.isWeekSun === true) {
            chkPuDays.push(0);
        }

        return chkPuDays;
    }

    getDaysOfMonthlyRec() {
        var chkPuMonths = [];
        if (this.state.isMonthMon === true) {
            chkPuMonths.push(1);
        }
        if (this.state.isMonthTue === true) {
            chkPuMonths.push(2);
        }
        if (this.state.isMonthWed === true) {
            chkPuMonths.push(3);
        }
        if (this.state.isMonthThu === true) {
            chkPuMonths.push(4);
        }
        if (this.state.isMonthFri === true) {
            chkPuMonths.push(5);
        }
        if (this.state.isMonthSat === true) {
            chkPuMonths.push(6);
        }
        if (this.state.isMonthSun === true) {
            chkPuMonths.push(0);
        }

        return chkPuMonths;
    }

    limitYearCreditCard(val, min) {
        if (val.length === 1 && val[0] < min[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val < min) {
                val = min;
            }
        }

        return val;
    }

    limitMonthCreditCard(val, max) {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    }

    cardExpiry(val) {
        let month = this.limitMonthCreditCard(val.substring(0, 2), '12');
        let date = this.limitYearCreditCard(val.substring(2, 4), currentTime.getFullYear().toString().substring(2, 4));
        let cardExpirydate = month + (date.length ? '/' + date : '');
        return cardExpirydate;

        //let month = this.limit(val.substring(0, 2), '12');
        //let year = val.substring(2, 4);
        //return month + (year.length ? '/' + year : '');
    }
    render() {
        const filterPassedTime = time => {
            const currentDate = currentTime;
            const selectedDate = new Date(time);

            return currentDate.getTime() < selectedDate.getTime();
        }
        const inputPropsPickup = {
            placeholder: 'Enter pick-up location',
            value: this.state.pickupLocation,
            onChange: this.onChangePickupLocation,
            onBlur: this.onBlurPickupLocation,
        };
        const inputPropsDropoff = {
            placeholder: 'Enter drop off location',
            value: this.state.dropoffLocation,
            onChange: this.onChangeDropoffLocation,
            onBlur: this.onBlurDropoffLocation,
        };

        let quoteIdStr = parseInt(this.state.quoteId) > 0 ? this.state.quoteId : "00000";
        let quoteStatus = this.state.tripDetails != null ? this.state.tripDetails.tripStatus : "NEW QUOTE";
        let quoteStatusId = this.state.tripDetails != null ? this.state.tripDetails.tripStatusId : 315;
        let createdBy = this.state.tripDetails != null ? this.state.tripDetails.createdByName : "";
        let createdDate = this.state.tripDetails != null ? this.state.tripDetails.createdDateStr : "";
        let confirmedBy = this.state.tripDetails != null ? this.state.tripDetails.confirmedBy : "";
        let confirmationNo = this.state.tripDetails != null ? this.state.tripDetails.confirmationNo : "";
        return (
            <div className="content-wrapper" id="bookingdiv">
                <form method="post" onSubmit={this.handleQuoteSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                    <div className="content-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <h1 className="m-0 text-dark">New Quotation</h1>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <NavItem><NavLink tag={Link} to="/quotation/list" className="btn btn-block btn-outline-secondary btn-sm" ><i className="fas fa-search"></i> Search Quotation</NavLink></NavItem>
                                        <NavItem><NavLink tag={Link} to="/reservations" className="btn btn-block btn-outline-secondary btn-sm" title="New Reservation"><i className="fas fa-plus"></i> New Reservation</NavLink></NavItem>
                                        <NavItem><NavLink tag={Link} to="/reservation/list" className="btn btn-block btn-outline-secondary btn-sm" title="Search Reservation"><i className="fas fa-search"></i> Search Reservation</NavLink></NavItem>
                                        <NavItem><NavLink tag={Link} to="/uploadschedule" className="btn btn-block btn-outline-secondary btn-sm" title="Upload Schedule"><i className="fas fa-clipboard-list"></i> Upload Schedule</NavLink></NavItem>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="rez-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    Quote Id <span className="text-info">{quoteIdStr}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Status <span className="text-info">{quoteStatus}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Quote Created By <span className="text-info">{createdBy}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Quote Date Time <span className="text-info">{createdDate}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {(confirmationNo != "") &&
                                        <span>Confirmed By <span className="text-info">{confirmedBy}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    Rez# <span className="text-info">{confirmationNo}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>}
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right">
                                    <button type="button" className="btn btn-success btn-sm" disabled={quoteStatusId == 318 || quoteStatusId == 317} onClick={this.handleQuoteSubmit} >
                                        {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                        {!this.state.isSubmited && <span title="Save"><i className="fas fa-save"></i> Save</span>}
                                    </button>&nbsp;&nbsp;&nbsp;
                                    {(quoteStatusId == 315 && this.state.quoteId > 0) && <span><button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleEmailSubmit} >
                                        {this.state.isEmailSubmited && <span title="In-process" ><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                        {!this.state.isEmailSubmited && <span title="Email"><i className="fas fa-envelope"></i> Email</span>}
                                    </button>&nbsp;&nbsp;&nbsp;</span>}
                                    {(this.state.quoteId > 0) && <span><button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleDownload} title="Download Quote"><i className="fas fa-download"></i> Download</button>&nbsp;&nbsp;&nbsp;</span>}
                                    {(quoteStatusId == 316 && this.state.quoteId > 0) && <span><button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleConfirmSubmit} title="Confirm"><i className="fas fa-check"></i> Confirm</button>&nbsp;&nbsp;&nbsp;</span>}
                                    {(quoteStatusId != 317 && this.state.quoteId > 0) && <span><button type="button" className="btn btn-custom-gray btn-sm" disabled={quoteStatusId == 318} onClick={this.handleCancelSubmit} >
                                        {this.state.isCancelSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                        {!this.state.isCancelSubmited && <span title="Cancel"><i className="fas fa-times"></i> Cancel</span>}
                                    </button>&nbsp;&nbsp;&nbsp;</span>}
                                    {(quoteStatusId == 315 && this.state.quoteId == 0) && <span><button type="button" className="btn btn-custom-gray btn-sm" onClick={this.clearAllControls} title="Clear"><i className="fas fa-eraser"></i> Clear</button>&nbsp;&nbsp;&nbsp;</span>}
                                    {(this.state.quoteId > 0 || this.state.rateLookup != null) && <span><button type="button" className="btn btn-custom-gray btn-sm" onClick={this.goToBack} title="Back"><i className="fas fa-arrow-left"></i> Back</button></span>}

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content" >
                        <div className="rez-container">
                            <div className="row">
                                <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                    <div className="card main-rez-card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-left">
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Passenger Details</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Passenger First Name <span className="text-danger">*</span></label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxFirstName} onChange={this.handleInputChange} name="paxFirstName" placeholder="Enter first name" />
                                                                        {this.state.errors["paxFirstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxFirstName"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Passenger Last Name <span className="text-danger">*</span></label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.paxLastName} onChange={this.handleInputChange} name="paxLastName" placeholder="Enter last name" />
                                                                        {this.state.errors["paxLastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paxLastName"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>Code</label>
                                                                                <input type="text" className="form-control form-control-sm" name="countryCodePhone" placeholder="+1" maxLength="2" title="Country Code" value={this.state.countryCodePhone} onChange={this.handleInputChange} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                                                            <div className="form-group">
                                                                                <label>Phone</label>
                                                                                <NumberFormat className="form-control form-control-sm" name="phoneNumber" placeholder="(000) 000-0000" title="Phone Number" value={this.state.phoneNumber} onChange={this.handleInputChange} format="###-###-####" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>Code <span className="text-red">*</span></label>
                                                                                <input type="text" className="form-control form-control-sm" name="countryCode" placeholder="+1" maxLength="2" title="Country Code" value={this.state.countryCode} onChange={this.handleInputChange} />
                                                                                {this.state.errors["countryCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["countryCode"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                                                            <div className="form-group">
                                                                                <label>Mobile Number <span className="text-danger">*</span></label>
                                                                                <NumberFormat className="form-control form-control-sm" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" />
                                                                                {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">

                                                                    <div className="form-group">
                                                                        <label style={{ display: this.state.quoteId == 0 ? 'none' : 'block' }} >Email</label>
                                                                        <span className="form-check" style={{ display: this.state.quoteId == 0 ? 'block' : 'none' }}>
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isSendEmail} onChange={this.handleInputChange} name="isSendEmail" />
                                                                            <label className="form-check-label">Send email as attachment</label>
                                                                        </span>
                                                                        <input type="text" className="form-control form-control-sm" name="email" placeholder="test@domain.com" maxLength="100" title="Email" value={this.state.email} onChange={this.handleInputChange} />
                                                                        {this.state.errors["email"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["email"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>PO / Client Ref #</label>
                                                                        <input type="text" className="form-control form-control-sm" placeholder="" name="poNumber" maxLength="100" title="PO / Client Ref #" value={this.state.poNumber} onChange={this.handleInputChange} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label className="btn-block">&nbsp;</label>
                                                                        <button type="button" className="btn btn-default btn-sm mt-1"><img src="../../dist/img/scanner.png" /></button>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                    <div className="form-group">
                                                                        <label>Pax # <span className="text-danger">*</span></label>
                                                                        <NumericInput className="form-control form-control-sm" name="noOfPax" title="Number of Pax" value={this.state.noOfPax} min={1} max={100} onChange={(value) => { this.handlePaxCountChange(value) }} />
                                                                        {this.state.errors["noOfPax"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfPax"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 col-sm-3 col-xs-3">
                                                                    <div className="form-group">
                                                                        <label>Bag#</label>
                                                                        <NumericInput className="form-control form-control-sm" name="luggage" title="Number of luggage" value={this.state.luggage} min={0} max={20} onChange={(value) => { this.setState({ luggage: value }) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Pick-up and Drop Off Details</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="form-group custom-control custom-switch swicth-group-checkbox">
                                                                <input type="checkbox" className="custom-control-input" onChange={this.handlePickupToggleChange} id="customSwitchPickup" />
                                                                <label className="custom-control-label" style={{ paddingTop: 5 + "px" }} htmlFor="customSwitchPickup">Add Google Address</label>
                                                            </div>

                                                            <div className="row" style={{ display: this.state.isPickupGoogleBooking ? 'none' : 'flex' }}>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Pick-up Location <span className="text-danger">*</span></label>
                                                                        <Autosuggest
                                                                            name="pickupLocation"
                                                                            focusInputOnSuggestionClick={true}
                                                                            suggestions={this.state.pickupSuggestions}
                                                                            onSuggestionsFetchRequested={this.onPickupSuggestionsFetchRequested}
                                                                            onSuggestionsClearRequested={this.onPickupSuggestionsClearRequested}
                                                                            getSuggestionValue={this.getPickupSuggestionValue}
                                                                            renderSuggestion={renderSuggestion}
                                                                            shouldRenderSuggestions={shouldRenderSuggestions}
                                                                            inputProps={inputPropsPickup}
                                                                            highlightFirstSuggestion={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                                    <div className="form-group">
                                                                        <label>Pick-up Address</label>
                                                                        <input type="text" className="form-control form-control-sm" placeholder="" name="pickupAddress" maxLength="150" title="Pickup Address" value={this.state.pickupAddress} onChange={this.handleInputChange} placeholder="Enter pick-up address" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ display: this.state.isPickupGoogleBooking ? 'flex' : 'none' }}>
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <label>Pick-up Location & Address <span className="text-danger">*</span></label>
                                                                        <input type="text" className="form-control form-control-sm" id="pickupGoogle" placeholder="'Type' slowly to search location" maxLength="150" title="Pickup Location & Address" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.errors["pickupLocation"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["pickupLocation"]}</span>}
                                                            <div className="row">

                                                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                                                    <div className="form-group">
                                                                        <label>Pick-up Zone <span className="text-danger">*</span></label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownZone.length > 0 ? this.state.dropdownZone : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select pick-up zone"
                                                                            name="pickupZoneId"
                                                                            defaultValue={0}
                                                                            value={this.state.pickupZoneId}
                                                                            displayExpr='name'
                                                                            valueExpr='id'
                                                                            onSelectionChanged={this.handlePickupZoneChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                        {this.state.errors["pickupZoneId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["pickupZoneId"]}</span>}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="form-group custom-control custom-switch swicth-group-checkbox">
                                                                <input type="checkbox" className="custom-control-input" onChange={this.handleDropoffToggleChange} id="customSwitchDropoff" />
                                                                <label className="custom-control-label" style={{ paddingTop: 5 + "px" }} htmlFor="customSwitchDropoff">Add Google Address</label>
                                                            </div>
                                                            <div className="row" style={{ display: this.state.isDropoffGoogleBooking ? 'none' : 'flex' }}>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Drop Off Location <span className="text-danger">*</span></label>
                                                                        <Autosuggest
                                                                            name="dropoffLocation"
                                                                            focusInputOnSuggestionClick={true}
                                                                            suggestions={this.state.dropoffSuggestions}
                                                                            onSuggestionsFetchRequested={this.onDropoffSuggestionsFetchRequested}
                                                                            onSuggestionsClearRequested={this.onDropoffSuggestionsClearRequested}
                                                                            getSuggestionValue={this.getDropoffSuggestionValue}
                                                                            renderSuggestion={renderSuggestion}
                                                                            shouldRenderSuggestions={shouldRenderSuggestions}
                                                                            inputProps={inputPropsDropoff}
                                                                            highlightFirstSuggestion={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                                    <div className="form-group">
                                                                        <label>Drop Off Address</label>
                                                                        <input type="text" className="form-control form-control-sm" placeholder="" name="dropoffAddress" maxLength="150" title="Dropoff Address" value={this.state.dropoffAddress} onChange={this.handleInputChange} placeholder="Enter drop off address" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ display: this.state.isDropoffGoogleBooking ? 'flex' : 'none' }}>
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <label>Drop Off Location & Address <span className="text-danger">*</span></label>
                                                                        <input type="text" className="form-control form-control-sm" id="dropoffGoogle" placeholder="'Type' slowly to search location" maxLength="150" title="Dropoff Location & Address" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.errors["dropoffLocation"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["dropoffLocation"]}</span>}
                                                            <div className="row">
                                                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                                                    <div className="form-group">
                                                                        <label>Drop Off Zone <span className="text-danger">*</span></label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownZone.length > 0 ? this.state.dropdownZone : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select drop off zone"
                                                                            name="dropoffZoneId"
                                                                            defaultValue={0}
                                                                            value={this.state.dropoffZoneId}
                                                                            displayExpr='name'
                                                                            valueExpr='id'
                                                                            onSelectionChanged={this.handleDropoffZoneChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                        {this.state.errors["dropoffZoneId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["dropoffZoneId"]}</span>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Flight Details</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                                                    <div className="form-group">
                                                                        <label>Airline Name</label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownAirline.length > 0 ? this.state.dropdownAirline : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select airline"
                                                                            name="airlineId"
                                                                            defaultValue={0}
                                                                            value={this.state.airlineId}
                                                                            displayExpr='airLineName'
                                                                            valueExpr='airLineId'
                                                                            onSelectionChanged={this.handleAirlineChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                    <div className="form-group">
                                                                        <label>Flight #</label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={25} value={this.state.flightNumber} onChange={this.handleInputChange} name="flightNumber" placeholder="Flight #" />
                                                                        {this.state.errors["flightNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["flightNumber"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                    <div className="form-group">
                                                                        <label>Terminal Type</label>
                                                                        <select className="form-control form-control-sm" name="terminalType" value={this.state.terminalType} onChange={this.handleInputChange} >
                                                                            <option value="0">Select terminal type</option>
                                                                            {
                                                                                terminalTypeData &&
                                                                                terminalTypeData.map((item, i) =>
                                                                                    (<option key={i} value={item.id}>{item.name}</option>))
                                                                            }
                                                                        </select>
                                                                        {this.state.errors["terminalType"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["terminalType"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                    <div className="form-group">
                                                                        <label>Terminal</label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={25} value={this.state.terminal} onChange={this.handleInputChange} name="terminal" placeholder="Terminal" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-right">
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Quotation Date Time Details</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                    <div className="form-group">
                                                                        <label htmlFor="">Flight Time <span className="text-danger">*</span></label>
                                                                        <DatePicker
                                                                            className="form-control form-control-sm"
                                                                            name="flightTime"
                                                                            placeholder="Select flight time"
                                                                            selected={this.state.flightTime}
                                                                            onChange={this.handleFlightDateTimeChange}
                                                                            showTimeSelect
                                                                            showTimeSelectOnly
                                                                            timeIntervals={15}
                                                                            timeCaption="Time"
                                                                            dateFormat="HH:mm"
                                                                            timeFormat="HH:mm"
                                                                            filterTime={filterPassedTime}
                                                                        />
                                                                        {this.state.errors["flightTime"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["flightTime"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                    <div className="form-group">
                                                                        <label>PU Date and Time <span className="text-danger">*</span></label>
                                                                        <DateBox type="datetime"
                                                                            className="form-control form-control-sm"
                                                                            name="puDateTime"
                                                                            placeholder="MM/dd/yyyy HH:mm"
                                                                            displayFormat="MM/dd/yyyy HH:mm"
                                                                            showAnalogClock={true}
                                                                            useMaskBehavior={true}
                                                                            defaultValue={this.state.puDateTime}
                                                                            value={this.state.puDateTime}
                                                                            onValueChanged={this.handlePickupDateTimeChange}
                                                                            width="100%"
                                                                            disabled={false}
                                                                            acceptCustomValue={false}
                                                                        />
                                                                        {this.state.errors["puDateTime"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["puDateTime"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-5 col-md-5 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Vehicle Type <span className="text-danger">*</span></label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownVehicleType.length > 0 ? this.state.dropdownVehicleType : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select vehicle type"
                                                                            name="vehicleTypeId"
                                                                            defaultValue={0}
                                                                            value={this.state.vehicleTypeId}
                                                                            displayExpr='apiVehicleTypeDescription'
                                                                            valueExpr='rowIndex'
                                                                            onSelectionChanged={this.handleVehicleTypeChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                        {this.state.errors["vehicleTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["vehicleTypeId"]}</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                    <div className="form-group">
                                                                        <label>Trip # <span className="text-danger">*</span></label>
                                                                        <NumericInput className="form-control form-control-sm" name="noOfTrip" title="Number of Trips" disabled={this.state.tripTypeId === "2" || this.state.tripTypeId === "3" || parseInt(this.state.paymentTermId) === 2 || this.state.quoteId > 0} value={this.state.noOfTrip} min={1} max={20} onChange={(value) => { this.setState({ noOfTrip: value }) }} />
                                                                        {this.state.errors["noOfTrip"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfTrip"]}</span>}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="radio" name="oneWay" value="1" checked={this.state.tripTypeId === "1"} disabled={this.state.quoteId > 0} onChange={this.handleTripTypeChange} />
                                                                            <label className="form-check-label">Oneway</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="radio" name="isReturnTrip" value="2" disabled={parseInt(this.state.paymentTermId) === 2 || this.state.quoteId > 0} checked={this.state.tripTypeId === "2"} onChange={this.handleTripTypeChange} />
                                                                            <label className="form-check-label">Round Trip</label>
                                                                        </span>
                                                                        <span className="form-check" style={{ display: 'none' }} >
                                                                            <input className="form-check-input" type="radio" name="isRecurring" value="3" disabled={parseInt(this.state.paymentTermId) === 2 || this.state.quoteId > 0} checked={this.state.tripTypeId === "3"} onChange={this.handleTripTypeChange} />
                                                                            <label className="form-check-label">Recurring</label>
                                                                        </span>

                                                                        <span className="form-check ml-3" style={{ display: 'none' }}>
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isVipTrip} onChange={this.handleInputChange} name="isVipTrip" />
                                                                            <label className="form-check-label">VIP</label>
                                                                        </span>
                                                                        <span className="form-check  ml-3" style={{ display: (rideTypeId == 1 || rideTypeId == 3) ? 'inline' : 'none' }}>
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMeetGreet} onChange={this.handleMeetGreetChange} name="isMeetGreet" />
                                                                            <label className="form-check-label">Meet & Greet</label>
                                                                        </span>
                                                                        <span className="form-check  ml-3">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isAccessible} onChange={this.handleInputChange} name="isAccessible" />
                                                                            <label className="form-check-label">Accessible</label>
                                                                        </span>
                                                                        <span className="form-check" style={{ display: 'none' }}>
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isPriorityTrip} onChange={this.handleInputChange} name="isPriorityTrip" />
                                                                            <label className="form-check-label">Priority Trip</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isLockRates} disabled={this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')} onChange={this.handleInputChange} name="isLockRates" />
                                                                            <label className="form-check-label">Lock Rates</label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {(this.state.tripTypeId === "2") && <div className="card sub-rez-card">
                                                                <div className="card-header">
                                                                    <h5 className="card-title m-0">Return Details</h5>
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="row">
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <label>Airline Name</label>
                                                                                <SelectBox
                                                                                    dataSource={this.state.dropdownAirline.length > 0 ? this.state.dropdownAirline : []}
                                                                                    className="basic-multi-select"
                                                                                    classNamePrefix="select"
                                                                                    placeholder="Select airline"
                                                                                    name="airlineIdReturn"
                                                                                    defaultValue={0}
                                                                                    value={this.state.airlineIdReturn}
                                                                                    displayExpr='airLineName'
                                                                                    valueExpr='airLineId'
                                                                                    onSelectionChanged={this.handleAirlineReturnChange}
                                                                                    showClearButton={true}
                                                                                    disabled={false}
                                                                                    searchEnabled={true}
                                                                                />
                                                                                {this.state.errors["airlineIdReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["airlineIdReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-3 col-sm-2 col-xs-2">
                                                                            <div className="form-group">
                                                                                <label>Flight #</label>
                                                                                <input type="text" className="form-control form-control-sm" maxLength={25} value={this.state.flightNumberReturn} onChange={this.handleInputChange} name="flightNumberReturn" placeholder="Enter flight #" />
                                                                                {this.state.errors["flightNumberReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["flightNumberReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>Terminal Type</label>
                                                                                <select className="form-control form-control-sm" name="terminalTypeReturn" value={this.state.terminalTypeReturn} onChange={this.handleInputChange} >
                                                                                    <option value="0">Select terminal type</option>
                                                                                    {
                                                                                        terminalTypeData &&
                                                                                        terminalTypeData.map((item, i) =>
                                                                                            (<option key={i} value={item.id}>{item.name}</option>))
                                                                                    }
                                                                                </select>
                                                                                {this.state.errors["terminalTypeReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["terminalTypeReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                            <div className="form-group">
                                                                                <label>Terminal</label>
                                                                                <input type="text" className="form-control form-control-sm" maxLength={25} value={this.state.terminalReturn} onChange={this.handleInputChange} name="terminalReturn" />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">

                                                                            <div className="form-group">
                                                                                <label>Pax # <span className="text-danger">*</span></label>
                                                                                <NumericInput className="form-control form-control-sm" name="noOfPaxReturn" title="Number of Pax" value={this.state.noOfPaxReturn} min={1} max={100} onChange={(value) => { this.handlePaxCountReturnChange(value) }} />
                                                                                {this.state.errors["noOfPaxReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfPaxReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <label htmlFor="">Pick-up Date & Tim</label>

                                                                                <DateBox type="datetime"
                                                                                    className="form-control form-control-sm"
                                                                                    name="puDateTimeReturn"
                                                                                    placeholder="MM/dd/yyyy HH:mm"
                                                                                    displayFormat="MM/dd/yyyy HH:mm"
                                                                                    showAnalogClock={true}
                                                                                    useMaskBehavior={true}
                                                                                    defaultValue={this.state.puDateTimeReturn}
                                                                                    value={this.state.puDateTimeReturn}
                                                                                    onValueChanged={this.handlePickupDateTimeReturnChange}
                                                                                    width="100%"
                                                                                    disabled={false}
                                                                                    acceptCustomValue={false}
                                                                                    min={this.state.puDateTime}
                                                                                />
                                                                                {this.state.errors["puDateTimeReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["puDateTimeReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                            <div className="form-group">
                                                                                <label htmlFor="">Flight Time</label>
                                                                                <DatePicker
                                                                                    className="form-control form-control-sm"
                                                                                    name="flightTimeReturn"
                                                                                    selected={this.state.flightTimeReturn}
                                                                                    onChange={this.handleFlightDateTimeReturnChange}
                                                                                    showTimeSelect
                                                                                    showTimeSelectOnly
                                                                                    timeIntervals={15}
                                                                                    timeCaption="Time"
                                                                                    dateFormat="HH:mm"
                                                                                    timeFormat="HH:mm"
                                                                                    filterTime={filterPassedTime}
                                                                                />
                                                                                {this.state.errors["flightTimeReturn"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["flightTimeReturn"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>}

                                                            {(this.state.tripTypeId === "3") && <div className="card sub-rez-card">
                                                                <div className="card-header">
                                                                    <h5 className="card-title m-0">Recurring Details</h5>
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>Repeat Type <span className="text-danger">*</span></label>
                                                                                <select className="form-control form-control-sm" name="recurringTypeId" value={this.state.recurringTypeId} onChange={this.handleInputChange}>
                                                                                    <option value="1">Daily</option>
                                                                                    <option value="2">Weekly</option>
                                                                                    <option value="3">Monthly</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>End Date <span className="text-danger">*</span></label>
                                                                                <DateBox type="date"
                                                                                    className="form-control form-control-sm"
                                                                                    name="recurringEndDate"
                                                                                    placeholder="mm/dd/yyyy"
                                                                                    useMaskBehavior={true}
                                                                                    defaultValue={this.state.recurringEndDate}
                                                                                    value={this.state.recurringEndDate}
                                                                                    onValueChanged={this.handleRecurringEndDateChange}
                                                                                    width="100%"
                                                                                    disabled={false}
                                                                                    acceptCustomValue={false}
                                                                                    min={this.state.puDateTime}
                                                                                />
                                                                                {this.state.errors["recurringEndDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["recurringEndDate"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {(this.state.recurringTypeId == 1 && this.state.tripTypeId === "3") && <div id="recurringDaily" className="row">
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                                    <div className="row">
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                            <div className="form-group">
                                                                                <div id="divrecurringDaily">
                                                                                    <DayPicker
                                                                                        selectedDays={this.state.selectedDays}
                                                                                        onDayClick={this.handleDayClick}
                                                                                    />

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {(this.state.recurringTypeId == 2 && this.state.tripTypeId === "3") && <div id="recurringWeekly" className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekSun} onChange={this.handleInputChange} name="isWeekSun" />
                                                                            <label className="form-check-label">SUN</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekMon} onChange={this.handleInputChange} name="isWeekMon" />
                                                                            <label className="form-check-label">MON</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekTue} onChange={this.handleInputChange} name="isWeekTue" />
                                                                            <label className="form-check-label">TUE</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekWed} onChange={this.handleInputChange} name="isWeekWed" />
                                                                            <label className="form-check-label">WED</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekThu} onChange={this.handleInputChange} name="isWeekThu" />
                                                                            <label className="form-check-label">THU</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekFri} onChange={this.handleInputChange} name="isWeekFri" />
                                                                            <label className="form-check-label">FRI</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isWeekSat} onChange={this.handleInputChange} name="isWeekSat" />
                                                                            <label className="form-check-label">SAT</label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {(this.state.recurringTypeId == 3 && this.state.tripTypeId === "3") && <div id="recurringMonthly" className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthSun} onChange={this.handleInputChange} name="isMonthSun" />
                                                                            <label className="form-check-label">SUN</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthMon} onChange={this.handleInputChange} name="isMonthMon" />
                                                                            <label className="form-check-label">MON</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthTue} onChange={this.handleInputChange} name="isMonthTue" />
                                                                            <label className="form-check-label">TUE</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthWed} onChange={this.handleInputChange} name="isMonthWed" />
                                                                            <label className="form-check-label">WED</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthThu} onChange={this.handleInputChange} name="isMonthThu" />
                                                                            <label className="form-check-label">THU</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthFri} onChange={this.handleInputChange} name="isMonthFri" />
                                                                            <label className="form-check-label">FRI</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isMonthSat} onChange={this.handleInputChange} name="isMonthSat" />
                                                                            <label className="form-check-label">SAT</label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {this.state.errors["recurring"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["recurring"]}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Other Details</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Order By <span className="text-danger">*</span></label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.orderByName} onChange={this.handleInputChange} name="orderByName" placeholder="Enter order by name" />
                                                                        {this.state.errors["orderByName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["orderByName"]}</span>}
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                            <div className="form-group">
                                                                                <label>Code</label>
                                                                                <input type="text" className="form-control form-control-sm" name="countryCodeOrderPhone" placeholder="+1" maxLength="2" title="Country Code" value={this.state.countryCodeOrderPhone} onChange={this.handleInputChange} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                                                            <div className="form-group">
                                                                                <label>Phone</label>
                                                                                <NumberFormat className="form-control form-control-sm" name="phoneNumberOrder" placeholder="(000) 000-0000" title="Phone Number" value={this.state.phoneNumberOrder} onChange={this.phoneNumberOrder} format="###-###-####" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>Order by Email</label>
                                                                        <input type="text" className="form-control form-control-sm" name="emailOrder" placeholder="example@domain.com" maxLength="100" title="Email" value={this.state.emailOrder} onChange={this.handleInputChange} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label htmlFor="">Reservation Mode <span className="text-danger">*</span></label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownReservationMode.length > 0 ? this.state.dropdownReservationMode : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select rez mode"
                                                                            name="reservationModeId"
                                                                            defaultValue={0}
                                                                            value={this.state.reservationModeId}
                                                                            displayExpr='name'
                                                                            valueExpr='id'
                                                                            onSelectionChanged={this.handleReservationModeChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                        {this.state.errors["reservationModeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["reservationModeId"]}</span>}

                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label htmlFor="">Service Source</label>
                                                                        <select className="form-control form-control-sm" name="serviceSourceId" value={this.state.serviceSourceId} onChange={this.handleInputChange}>
                                                                            <option value="1">In House</option>
                                                                            <option value="2">Farm In</option>
                                                                            <option value="3">Farm Out</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                {(this.state.serviceSourceId != 1) && <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label htmlFor="">Affiliate <span className="text-danger">*</span></label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownAffiliates.length > 0 ? this.state.dropdownAffiliates : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select Affliates"
                                                                            name="otherAffiliateId"
                                                                            defaultValue={0}
                                                                            value={this.state.otherAffiliateId}
                                                                            displayExpr='name'
                                                                            valueExpr='id'
                                                                            onSelectionChanged={this.handleAffiliateChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                        {this.state.errors["otherAffiliateId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["otherAffiliateId"]}</span>}
                                                                    </div>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Notes</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <ul className="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                                                                        <li className="nav-item">
                                                                            <a className="nav-link active" id="trip-notes-tab" data-toggle="pill" href="#trip-notes" role="tab" aria-controls="trip-notes" aria-selected="true">Trip Notes</a>
                                                                        </li>
                                                                        <li className="nav-item" style={{ display: 'none' }}>
                                                                            <a className="nav-link" id="bill-to-notes-tab" data-toggle="pill" href="#bill-to-notes" role="tab" aria-controls="bill-to-notes" aria-selected="false">Bill To / Pax Notes</a>
                                                                        </li>
                                                                        <li className="nav-item" style={{ display: 'none' }}>
                                                                            <a className="nav-link" id="pickup-to-notes-tab" data-toggle="pill" href="#pickup-to-notes" role="tab" aria-controls="pickup-to-notes" aria-selected="false">Pickup Notes</a>
                                                                        </li>
                                                                    </ul>
                                                                    <div className="tab-content" id="custom-content-below-tabContent">
                                                                        <div className="tab-pane fade show active" id="trip-notes" role="tabpanel" aria-labelledby="trip-notes-tab">
                                                                            <div className="row">
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <textarea className="form-control form-control-sm" rows="3" name="specialInstruction" placeholder="Enter special instruction" maxLength="500" title="Special Instruction" value={this.state.specialInstruction} onChange={this.handleInputChange} />
                                                                                    </div>
                                                                                    <div className="form-group">
                                                                                        <textarea className="form-control form-control-sm" rows="3" name="permanentRemark" placeholder="Enter permanent remark" maxLength="500" title="Permanent Remark" value={this.state.permanentRemark} onChange={this.handleInputChange} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="tab-pane fade" id="bill-to-notes" role="tabpanel" aria-labelledby="bill-to-notes-tab">
                                                                            <div className="row">
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <textarea className="form-control form-control-sm" rows="6" name="billToNotes" placeholder="Eenter bill to notes" maxLength="1000" title="Bill To Notes" value={this.state.billToNotes} onChange={this.handleInputChange} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="tab-pane fade" id="pickup-to-notes" role="tabpanel" aria-labelledby="pickup-to-notes-tab">
                                                                            <div className="row">
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                                    <div className="form-group">
                                                                                        <textarea className="form-control form-control-sm" rows="6" name="pickupNotes" placeholder="Enter pick-up notes" maxLength="1000" title="Pickup Notes" value={this.state.pickupNotes} onChange={this.handleInputChange} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="card sub-rez-card">
                                                        <div className="card-header">
                                                            <h5 className="card-title m-0">Tax Option</h5>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="radio" name="includedInFare" value="2" checked={this.state.taxOptionId === "2"} onChange={this.handleTaxOptionChange} />
                                                                            <label className="form-check-label">Included In Fare</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="radio" name="addToFare" value="3" checked={this.state.taxOptionId === "3"} onChange={this.handleTaxOptionChange} />
                                                                            <label className="form-check-label">Add To Fare</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="radio" name="exempted" value="1" checked={this.state.taxOptionId === "1"} onChange={this.handleTaxOptionChange} />
                                                                            <label className="form-check-label">Exempted</label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="form-group">
                                                                        <span className="form-check" style={{ display: this.state.taxOptionId !== "1" ? 'inline-block' : 'none' }}>
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isAppliedPortAuthority} onChange={this.handleTaxOptionChange} name="isAppliedPortAuthority" />
                                                                            <label className="form-check-label">Port Authority</label>
                                                                        </span>
                                                                        <span className="form-check" >
                                                                            <input className="form-check-input" type="checkbox" checked={this.state.isAppliedSalesTax} onChange={this.handleTaxOptionChange} name="isAppliedSalesTax" />
                                                                            <label className="form-check-label">Sales Tax</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" id="isAccessible" checked={this.state.isAppliedCountyTax} onChange={this.handleTaxOptionChange} name="isAppliedCountyTax" />
                                                                            <label className="form-check-label">County Tax</label>
                                                                        </span>
                                                                        <span className="form-check">
                                                                            <input className="form-check-input" type="checkbox" id="isPriorityTrip" checked={this.state.isAppliedCongestionTax} onChange={this.handleTaxOptionChange} name="isAppliedCongestionTax" />
                                                                            <label className="form-check-label">Congestion Tax</label>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{ display: 'none' }}>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <div className="card sub-rez-card">
                                                        <div className="card-body p-0">
                                                            <div className="row">
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">


                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">


                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div className="card sub-rez-card">
                                                                        <div className="card-header">
                                                                            <h5 className="card-title m-0">Payment Details</h5>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="row">
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Payment Method</label>
                                                                                        <SelectBox
                                                                                            dataSource={this.state.dropdownPaymentType.length > 0 ? this.state.dropdownPaymentType : []}
                                                                                            className="basic-multi-select"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Select Payment Type"
                                                                                            name="paymentTypeId"
                                                                                            defaultValue={0}
                                                                                            value={this.state.paymentTypeId}
                                                                                            displayExpr='name'
                                                                                            valueExpr='id'
                                                                                            onSelectionChanged={this.handlePaymentTypeChange}
                                                                                            showClearButton={true}
                                                                                            disabled={(this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')) || (parseInt(this.state.paymentTermId) === 2 && this.state.quoteId > 0)}
                                                                                            searchEnabled={true}
                                                                                        />
                                                                                        {this.state.errors["paymentTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paymentTypeId"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Payment Terms</label>
                                                                                        <select className="form-control form-control-sm" name="paymentTermId" value={this.state.paymentTermId} disabled={this.state.quoteId > 0} onChange={this.handleInputChange}>
                                                                                            <option value={1}>Paid In Full</option>
                                                                                            <option value={2}>Paid In Partial</option>
                                                                                        </select>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Total Paid Amount</label>
                                                                                        <NumberFormat className="form-control form-control-sm" name="paidAmount" disabled={(parseInt(this.state.paymentTermId) === 1) || (this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x')) || (parseInt(this.state.paymentTermId) === 2 && this.state.quoteId > 0)} fixedDecimalScale={true} maxLength={12} prefix={'$'} decimalScale={3} title="Paid Amount" value={this.state.paidAmount} onValueChange={(values) => { this.setState({ paidAmount: values.floatValue }) }} />
                                                                                        {this.state.errors["paidAmount"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["paidAmount"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Check No</label>
                                                                                        <input type="text" className="form-control form-control-sm" name="checkNumber" disabled={this.state.paymentTypeId !== 4} placeholder="Enter Check Number" maxLength="12" title="Check Number" value={this.state.checkNumber} onChange={this.handleInputChange} />
                                                                                        {this.state.errors["checkNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkNumber"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Check Date</label>
                                                                                        <DatePicker
                                                                                            className="form-control form-control-sm "
                                                                                            placeholderText="Select check date"
                                                                                            name="checkDate"
                                                                                            selected={this.state.checkDate}
                                                                                            dateFormat="MM/dd/yyyy"
                                                                                            onChange={date => this.setState({ checkDate: date })}
                                                                                            disabled={this.state.paymentTypeId !== 4}
                                                                                        />
                                                                                        {this.state.errors["checkDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkDate"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Bank Name</label>
                                                                                        <input type="text" className="form-control form-control-sm" disabled={this.state.paymentTypeId !== 4} name="checkBank" placeholder="Enter Bank Name" maxLength="50" title="Bank Name" value={this.state.checkBank} onChange={this.handleInputChange} />
                                                                                        {this.state.errors["checkBank"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["checkBank"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3" style={{ display: 'none' }}>
                                                                                    <div className="form-group">
                                                                                        <label>New/Existing Card</label>
                                                                                        <SelectBox
                                                                                            dataSource={this.state.dropdownExistingCards.length > 0 ? this.state.dropdownExistingCards : []}
                                                                                            className="basic-multi-select"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Select cc"
                                                                                            name="existingCardId"
                                                                                            defaultValue={0}
                                                                                            value={this.state.existingCardId}
                                                                                            displayExpr='name'
                                                                                            valueExpr='id'
                                                                                            onSelectionChanged={this.handleExistingCardChange}
                                                                                            showClearButton={true}
                                                                                            disabled={this.state.paymentTypeId !== 2}
                                                                                            searchEnabled={true}
                                                                                        />
                                                                                        {this.state.errors["existingCardId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["existingCardId"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                                    <div className="form-group">
                                                                                        <label>Card Number</label>
                                                                                        <div className="input-group mb-3">
                                                                                            <NumberFormat className="form-control form-control-sm" isNumericString={this.state.quoteId > 0 ? true : false} name="creditCard" format="#### #### #### ####" disabled={this.state.paymentTypeId !== 2 || (this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x'))} value={this.state.creditCard} onChange={this.handleInputChange} />
                                                                                            <div className="input-group-append">
                                                                                                <div className="input-group-text">
                                                                                                    <img src={this.state.cardImage} width="20" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        {this.state.errors["creditCard"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditCard"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Card Type</label>
                                                                                        <select name="cardType" className="form-control form-control-sm" value={this.state.cardType} disabled={this.state.paymentTypeId !== 2 || (this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x'))} onChange={this.handleInputChange}>
                                                                                            <option value="0">Select Card Type</option>
                                                                                            {
                                                                                                CardTypes &&
                                                                                                CardTypes.map((item, i) =>
                                                                                                    (<option key={i} value={item.name}>{item.name}</option>))
                                                                                            }
                                                                                        </select>
                                                                                        {this.state.errors["cardType"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardType"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                                                                                    <div className="form-group">
                                                                                        <label>Card Expiry</label>
                                                                                        <NumberFormat className="form-control form-control-sm" name="cardExpiry" disabled={this.state.paymentTypeId !== 2 || (this.state.quoteId > 0 && this.state.paymentTypeId === 2 && this.state.creditCard.includes('x'))} placeholder="MM/YY" format={this.cardExpiry} title="Credit Card Expiry" value={this.state.cardExpiry} onValueChange={(values) => { const { formattedValue, value } = values; this.setState({ cardExpiry: formattedValue }) }} />
                                                                                        {this.state.errors["cardExpiry"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["cardExpiry"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Company</label>
                                                                                        <SelectBox
                                                                                            dataSource={this.state.dropdownVoucherCompany.length > 0 ? this.state.dropdownVoucherCompany : []}
                                                                                            className="basic-multi-select"
                                                                                            classNamePrefix="select"
                                                                                            placeholder="Select company"
                                                                                            name="voucherCompanyId"
                                                                                            defaultValue={0}
                                                                                            value={this.state.voucherCompanyId}
                                                                                            displayExpr='name'
                                                                                            valueExpr='id'
                                                                                            onSelectionChanged={this.handleVoucherCompanyChange}
                                                                                            showClearButton={true}
                                                                                            disabled={this.state.paymentTypeId !== 7}
                                                                                            searchEnabled={true}
                                                                                        />
                                                                                        {this.state.errors["voucherCompanyId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["voucherCompanyId"]}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                                                    <div className="form-group">
                                                                                        <label>Voucher</label>
                                                                                        <input type="text" className="form-control form-control-sm" name="voucherCode" disabled={this.state.paymentTypeId !== 7} placeholder="Enter Voucher Code" maxLength="50" title="Voucher Code" value={this.state.voucherCode} onChange={this.handleInputChange} />
                                                                                        {this.state.errors["voucherCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["voucherCode"]}</span>}
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="row">
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">


                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">


                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                    <div className="card main-rez-card">
                                        <div className="card-body">
                                            <div className="card sub-rez-card">
                                                <div className="card-header">
                                                    <h5 className="card-title m-0">Fare Details</h5>
                                                </div>
                                                <div className="card-body">
                                                    <ul className="nav nav-tabs" id="custom-content-below-tab" role="tablist">
                                                        <li className="nav-item">
                                                            <a className="nav-link active" id="custom-content-below-home-tab" data-toggle="pill" href="#custom-content-below-home" role="tab" aria-controls="custom-content-below-home" aria-selected="true">Customer Fare</a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a className="nav-link" id="custom-content-below-profile-tab" data-toggle="pill" href="#custom-content-below-profile" role="tab" aria-controls="custom-content-below-profile" aria-selected="false">Farm-out Cost</a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content" id="custom-content-below-tabContent">
                                                        <div className="tab-pane fade show active" id="custom-content-below-home" role="tabpanel" aria-labelledby="custom-content-below-home-tab">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Ride Amount <span className="text-danger">*</span></label>
                                                                        <NumberFormat className="form-control form-control-sm" name="rideAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Ride Amount" value={this.state.rideAmount} onValueChange={(values) => { this.handleRateChange("rideAmount", values.floatValue) }} />
                                                                        {this.state.errors["rideAmount"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["rideAmount"]}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Toll Amount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="tollAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Toll Amount" value={this.state.tollAmount} onValueChange={(values) => { this.handleRateChange("tollAmount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Tip Amount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="tipAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Tip Amount" value={this.state.tipAmount} onValueChange={(values) => { this.handleRateChange("tipAmount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Overtime Charge</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="otAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Overtime Amount" value={this.state.otAmount} onValueChange={(values) => { this.handleRateChange("otAmount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Service Fee</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="serviceFeeAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Service Fee Amount" value={this.state.serviceFeeAmount} onValueChange={(values) => { this.handleRateChange("serviceFeeAmount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Fuel Surcharge</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="fuelSurcharge" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Fuel Surcharge" value={this.state.fuelSurcharge} onValueChange={(values) => { this.handleRateChange("fuelSurcharge", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                    <div className="form-group">
                                                                        <label>Parking Fee</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="parkingFee" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Parking Fee" value={this.state.parkingFee} onValueChange={(values) => { this.handleRateChange("parkingFee", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5">
                                                                    <div className="form-group">
                                                                        <label>Tour Guide Charge</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="tourGuideCharge" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Tour Guide Charge" value={this.state.tourGuideCharge} onValueChange={(values) => { this.handleRateChange("tourGuideCharge", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Pay to Tour Guide</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="payToTourGuide" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Pay to Tour Guide" value={this.state.payToTourGuide} onValueChange={(values) => { this.handleRateChange("payToTourGuide", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>Extra Amount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="extraAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Extra Amount" value={this.state.extraAmount} onValueChange={(values) => { this.handleRateChange("extraAmount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>Extra Amount For</label>
                                                                        <input type="text" className="form-control form-control-sm" maxLength={50} value={this.state.extraAmountFor} onChange={this.handleInputChange} name="extraAmountFor" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Waiting Chg.</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="waitingCharge" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Waiting Charge" value={this.state.waitingCharge} onValueChange={(values) => { this.handleRateChange("waitingCharge", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Waiting Time (Min.)</label>
                                                                        <NumericInput className="form-control form-control-sm" name="waitingTime" title="Waiting Time" value={this.state.waitingTime} min={0} max={1000} onChange={(value) => { this.handleRateChange("waitingTime", value) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Waiting Total</label>
                                                                        <NumberFormat className="form-control form-control-sm" readOnly={true} name="waitingChargeTotal" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Waiting Charge Total" value={this.state.waitingChargeTotal} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Extra Stop Charge</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="extraStopCharge" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Extra Stop Charge" value={this.state.extraStopCharge} onValueChange={(values) => { this.handleRateChange("extraStopCharge", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>No of Stops</label>
                                                                        <NumericInput className="form-control form-control-sm" name="noOfStops" title="No Of Stops" value={this.state.noOfStops} min={0} max={100} onChange={(value) => { this.handleRateChange("noOfStops", value) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Stop Total</label>
                                                                        <NumberFormat className="form-control form-control-sm" readOnly={true} name="stopTotal" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Stop Total" value={this.state.stopTotal} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group" style={{ display: (this.state.isMeetGreet) ? 'inline' : 'none' }}>
                                                                        <label>Meet & Greet</label>
                                                                        <NumberFormat className="form-control form-control-sm" style={{ borderColor: "red" }} name="meetGreet" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Stop Total" value={this.state.meetGreet} onValueChange={(values) => { this.handleRateChange("meetGreet", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">

                                                                </div>
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ display: 'none' }}>
                                                                    <div className="row">
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="radio" name="rdPayToGreeter" value="1" checked={this.state.mgToPay === "1"} onChange={this.handleMgToPay} />
                                                                                    <label className="form-check-label">Pay to Greeter</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="radio" name="rdPayToCompany" value="2" checked={this.state.mgToPay === "2"} onChange={this.handleMgToPay} />
                                                                                    <label className="form-check-label">100% Comp.</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="radio" name="rdPayToDriver" value="3" checked={this.state.mgToPay === "3"} onChange={this.handleMgToPay} />
                                                                                    <label className="form-check-label">Pay to Driver</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                                                            <div className="form-group">
                                                                                <label>Greeter Name</label>
                                                                                <SelectBox
                                                                                    dataSource={this.state.dropdownGreeter.length > 0 ? this.state.dropdownGreeter : []}
                                                                                    className="basic-multi-select"
                                                                                    classNamePrefix="select"
                                                                                    placeholder="Select greeter"
                                                                                    name="payMeetGreetId"
                                                                                    defaultValue={0}
                                                                                    value={this.state.payMeetGreetId}
                                                                                    displayExpr='name'
                                                                                    valueExpr='id'
                                                                                    onSelectionChanged={this.handleGreeterChange}
                                                                                    showClearButton={true}
                                                                                    disabled={this.state.mgToPay === "2" || this.state.mgToPay === "3"}
                                                                                    searchEnabled={true}
                                                                                />
                                                                                {this.state.errors["payMeetGreetId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["payMeetGreetId"]}</span>}

                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                            <div className="form-group">
                                                                                <label>Amount</label>
                                                                                <NumberFormat className="form-control form-control-sm" disabled={this.state.mgToPay === "2" || this.state.mgToPay === "3"} name="payMeetGreetAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Extra Amount" value={this.state.payMeetGreetAmount} onValueChange={(values) => { this.setState({ payMeetGreetAmount: values.floatValue }) }} />
                                                                                {this.state.errors["payMeetGreetAmount"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["payMeetGreetAmount"]}</span>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <div className="row">
                                                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="radio" disabled={this.state.mgToPay === "1" || this.state.mgToPay === "2"} name="rdDriver100" value="1" checked={this.state.mgDriverComms === "1"} onChange={this.handleDriverCommissionPay} />
                                                                                    <label className="form-check-label">100%</label>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="radio" disabled={this.state.mgToPay === "1" || this.state.mgToPay === "2"} name="rdDriverSplit" value="2" checked={this.state.mgDriverComms === "2"} onChange={this.handleDriverCommissionPay} />
                                                                                    <label className="form-check-label">Split</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>Agent Comms.</label>
                                                                        <SelectBox
                                                                            dataSource={this.state.dropdownAgentCommission.length > 0 ? this.state.dropdownAgentCommission : []}
                                                                            className="basic-multi-select"
                                                                            classNamePrefix="select"
                                                                            placeholder="Select agent comm"
                                                                            name="agentCommissionId"
                                                                            defaultValue={0}
                                                                            value={this.state.agentCommissionId}
                                                                            displayExpr='name'
                                                                            valueExpr='id'
                                                                            onSelectionChanged={this.handleAgentCommissionChange}
                                                                            showClearButton={true}
                                                                            disabled={false}
                                                                            searchEnabled={true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{ display: 'none' }}>
                                                                    <div className="form-group">
                                                                        <label>Amount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="agentCommissionAmount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Agent Commission Amount" value={this.state.agentCommissionAmount} onValueChange={(values) => { this.setState({ agentCommissionAmount: values.floatValue }) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Port Authority</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="portAuthority" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Port Authority" value={this.state.portAuthority} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Utility</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="utitity" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Utitity" value={this.state.utitity} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>County Tax</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="countyTax" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="County Tax" value={this.state.countyTax} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Congestion Tax</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="congestionTax" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Congestion Tax" value={this.state.congestionTax} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>WC</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="workCompantation" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Work Compantation" value={this.state.workCompantation} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                                    <div className="form-group">
                                                                        <label>Sales Tax</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="salesTax" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Sales Tax" value={this.state.salesTax} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                                    <div className="form-group">
                                                                        <label>Gross Amount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="grossAmount" readOnly={true} fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Gross Amount" value={this.state.grossAmount} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                                    <div className="form-group">
                                                                        <label>Discount</label>
                                                                        <NumberFormat className="form-control form-control-sm" name="discount" fixedDecimalScale={true} maxLength={10} prefix={'$'} decimalScale={3} title="Discount Amount" value={this.state.discount} onValueChange={(values) => { this.handleRateChange("discount", values.floatValue) }} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                                                                    <div className="form-group">
                                                                        <label>&nbsp;</label>
                                                                        <h5>Total: ${this.state.totalFare}</h5>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="tab-pane fade" id="custom-content-below-profile" role="tabpanel" aria-labelledby="custom-content-below-profile-tab">
                                                            <h5>Comming Soon...</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <LoadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        position={position}
                        visible={this.state.loadPanelVisible}
                        showIndicator={true}
                        shading={true}
                        showPane={true}
                        closeOnOutsideClick={false}
                    />
                </form>
                {(quoteStatusId == 316 && this.state.quoteId > 0) && <ConfirmQuoteComponent ref="confirmQuoteModal" goToBack={this.goToBack} />}
                <VoucherEmailComponent ref="voucherEmailComponent" goToBack={this.goToBack} />
            </div>
        );
    }
}